/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AddReferenceRequest,
  AddUsersToCompanyRequest,
  AppendCostRequest,
  AppsumoWebookNotification,
  BatchInterviewRequest,
  BearerResponse,
  BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost,
  BodyLoginApiV1AuthLoginPost,
  BodyResetForgotPasswordApiV1AuthForgotPasswordPost,
  BodyResetResetPasswordApiV1AuthResetPasswordPost,
  BodySaveFileApiV1FilesPost,
  BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch,
  BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost,
  BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost,
  BodyVerifyVerifyApiV1AuthVerifyPost,
  CreateArtificRequest,
  CreateCheckoutRequest,
  CreateCompanyRequest,
  CreateEmployerRequest,
  CreateEvaluationTemplateRequest,
  CreateInterviewRequest,
  CreateInterviewTransactionRequest,
  CreateNotificationEmailRequest,
  CreateProfileRequest,
  DeleteUserRequest,
  DurationTickRequest,
  EmployerResponse,
  ErrorModel,
  EvaluateInterviewRequest,
  FirebaseLoginRequest,
  GenerateInterviewStreamRequest,
  GenerateWelcomeBackRequest,
  GetCheckoutResponse,
  GetCompanyResponse,
  GetCompanyResponseV2,
  GetEvaluationTemplateResponse,
  GetExpertResponse,
  GetFileResponse,
  GetHeygenConfigResponse,
  GetHeygenCreateTokenResponse,
  GetHistoryApiV1HistoryArtificIdMessagesGetParams,
  GetInterviewDetailsResponse,
  GetInterviewEvaluationResponse,
  GetInterviewResponse,
  GetInterviewStateApiV1InterviewsStateGetParams,
  GetInterviewStateResponse,
  GetInterviewTransactionResponse,
  GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams,
  GetListApiV1EmployersGetParams,
  GetListFilesResponse,
  GetNotificationEmailResponse,
  GetProfileApiV1UsersSelfProfileGetParams,
  GetProfileResponse,
  GetPushDeliveryResponse,
  GetReferenceResponse,
  GetStatisticsApiV1StatisticsGetParams,
  GetStatisticsResponse,
  GetSubscriptionPlansApiV1SubscriptionsPlansGetParams,
  GetVacancyInferenceSettingsResponse,
  GetVacancyResponse,
  GetVacancyUISettingsResponse,
  HTTPValidationError,
  HttpResponse,
  ImportVacancyFromTextRequest,
  ImportVacancyFromTextResponse,
  LicenseResponse,
  ListArtificsApiV1ExpertsGetParams,
  ListCheckoutItemsApiV1CheckoutsListItemsGetParams,
  ListCheckoutItemsResponse,
  ListCompaniesApiV1CompaniesGetParams,
  ListCompaniesResponse,
  ListEmployersResponse,
  ListExpertsResponse,
  ListInterviewResultsResponse,
  ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams,
  ListInterviewTransactionsResponse,
  ListInterviewsApiV1InterviewsResultsGetParams,
  ListMessagesResponse,
  ListNotificationEmailsApiV1NotificationsEmailsGetParams,
  ListNotificationEmailsResponse,
  ListPushDeliveriesApiV1PushDeliveriesGetParams,
  ListPushDeliveriesResponse,
  ListReferenceResponse,
  ListUsersApiV1UsersGetParams,
  ListUsersResponse,
  ListVacanciesApiV1VacanciesGetParams,
  ListVacanciesResponse,
  ListVacancyCriteriaResponse,
  ListVacancyRedFlagResponse,
  LivenessV1StatusLivenessGet200,
  LivenessV1StatusReadinessGet200,
  MarkServiceErrorRequest,
  MessageResponse,
  PaddleWebhookApiV1PaymentsPaddlePostBody,
  PlansListResponse,
  PushDeliveryCreate,
  PushDeliveryUpdate,
  ReferenceType,
  SendSinglePushRequest,
  SrcDomainsArtificSchemasGetVoicesResponse,
  SrcDomainsVacancySchemasGetVoicesResponse,
  StoreNotificationEmailsRequest,
  StoreVacancyRedFlagResponse,
  StringOrNoneResponse,
  SubmitGenerationRequest,
  SubscriptionErrorResponse,
  SumbitFormsRequest,
  UpdateArtificRequest,
  UpdateCompanyRequest,
  UpdateEvaluationTemplateRequest,
  UpdateInterviewRequest,
  UpdateMessageRequest,
  UpdateNotificationEmailRequest,
  UpdateProfileRequest,
  UpdateReferenceRequest,
  UpdateVacancyCriteriaResponse,
  UpdateVacancyUISettingsRequest,
  UpdateVacancyUISettingsResponse,
  UseLicenseKeyRequest,
  UserCreate,
  UserRead,
  UserResponse,
  UserSubscription,
  UserUpdate,
  VacancyCreateRequest,
  VacancyCriteriaStoreRequest,
  VacancyInferenceSettingsUpdateRequest,
  VacancyRedFlagStoreRequest,
  VacancyUpdateRequest,
  VideoAvatarResource
} from './openapi-generated.schemas'
import { platformInstance } from '../mutator/platform-instance'

/**
 * @summary Register:Register
 */
export const registerRegisterApiV1AuthRegisterPost = (
  userCreate: UserCreate
) => {
  return platformInstance<UserRead>({
    url: `/api/v1/auth/register`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: userCreate
  })
}

export const getRegisterRegisterApiV1AuthRegisterPostMutationOptions = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>,
    TError,
    { data: UserCreate },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>,
  TError,
  { data: UserCreate },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>,
    { data: UserCreate }
  > = (props) => {
    const { data } = props ?? {}

    return registerRegisterApiV1AuthRegisterPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type RegisterRegisterApiV1AuthRegisterPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>
>
export type RegisterRegisterApiV1AuthRegisterPostMutationBody = UserCreate
export type RegisterRegisterApiV1AuthRegisterPostMutationError =
  | ErrorModel
  | HTTPValidationError

/**
 * @summary Register:Register
 */
export const useRegisterRegisterApiV1AuthRegisterPost = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>,
    TError,
    { data: UserCreate },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof registerRegisterApiV1AuthRegisterPost>>,
  TError,
  { data: UserCreate },
  TContext
> => {
  const mutationOptions =
    getRegisterRegisterApiV1AuthRegisterPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Verify:Request-Token
 */
export const verifyRequestTokenApiV1AuthRequestVerifyTokenPost = (
  bodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost
) => {
  return platformInstance<unknown>({
    url: `/api/v1/auth/request-verify-token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost
  })
}

export const getVerifyRequestTokenApiV1AuthRequestVerifyTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>
      >,
      TError,
      { data: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>
    >,
    TError,
    { data: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>
      >,
      { data: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost }
    > = (props) => {
      const { data } = props ?? {}

      return verifyRequestTokenApiV1AuthRequestVerifyTokenPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type VerifyRequestTokenApiV1AuthRequestVerifyTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>
    >
  >
export type VerifyRequestTokenApiV1AuthRequestVerifyTokenPostMutationBody =
  BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost
export type VerifyRequestTokenApiV1AuthRequestVerifyTokenPostMutationError =
  HTTPValidationError

/**
 * @summary Verify:Request-Token
 */
export const useVerifyRequestTokenApiV1AuthRequestVerifyTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>
    >,
    TError,
    { data: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyRequestTokenApiV1AuthRequestVerifyTokenPost>>,
  TError,
  { data: BodyVerifyRequestTokenApiV1AuthRequestVerifyTokenPost },
  TContext
> => {
  const mutationOptions =
    getVerifyRequestTokenApiV1AuthRequestVerifyTokenPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Verify:Verify
 */
export const verifyVerifyApiV1AuthVerifyPost = (
  bodyVerifyVerifyApiV1AuthVerifyPost: BodyVerifyVerifyApiV1AuthVerifyPost
) => {
  return platformInstance<UserRead>({
    url: `/api/v1/auth/verify`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bodyVerifyVerifyApiV1AuthVerifyPost
  })
}

export const getVerifyVerifyApiV1AuthVerifyPostMutationOptions = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>,
    TError,
    { data: BodyVerifyVerifyApiV1AuthVerifyPost },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>,
  TError,
  { data: BodyVerifyVerifyApiV1AuthVerifyPost },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>,
    { data: BodyVerifyVerifyApiV1AuthVerifyPost }
  > = (props) => {
    const { data } = props ?? {}

    return verifyVerifyApiV1AuthVerifyPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type VerifyVerifyApiV1AuthVerifyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>
>
export type VerifyVerifyApiV1AuthVerifyPostMutationBody =
  BodyVerifyVerifyApiV1AuthVerifyPost
export type VerifyVerifyApiV1AuthVerifyPostMutationError =
  | ErrorModel
  | HTTPValidationError

/**
 * @summary Verify:Verify
 */
export const useVerifyVerifyApiV1AuthVerifyPost = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>,
    TError,
    { data: BodyVerifyVerifyApiV1AuthVerifyPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyVerifyApiV1AuthVerifyPost>>,
  TError,
  { data: BodyVerifyVerifyApiV1AuthVerifyPost },
  TContext
> => {
  const mutationOptions =
    getVerifyVerifyApiV1AuthVerifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Reset:Forgot Password
 */
export const resetForgotPasswordApiV1AuthForgotPasswordPost = (
  bodyResetForgotPasswordApiV1AuthForgotPasswordPost: BodyResetForgotPasswordApiV1AuthForgotPasswordPost
) => {
  return platformInstance<unknown>({
    url: `/api/v1/auth/forgot-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bodyResetForgotPasswordApiV1AuthForgotPasswordPost
  })
}

export const getResetForgotPasswordApiV1AuthForgotPasswordPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>
      >,
      TError,
      { data: BodyResetForgotPasswordApiV1AuthForgotPasswordPost },
      TContext
    >
  }): UseMutationOptions<
    Awaited<ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>>,
    TError,
    { data: BodyResetForgotPasswordApiV1AuthForgotPasswordPost },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>
      >,
      { data: BodyResetForgotPasswordApiV1AuthForgotPasswordPost }
    > = (props) => {
      const { data } = props ?? {}

      return resetForgotPasswordApiV1AuthForgotPasswordPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type ResetForgotPasswordApiV1AuthForgotPasswordPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>>
  >
export type ResetForgotPasswordApiV1AuthForgotPasswordPostMutationBody =
  BodyResetForgotPasswordApiV1AuthForgotPasswordPost
export type ResetForgotPasswordApiV1AuthForgotPasswordPostMutationError =
  HTTPValidationError

/**
 * @summary Reset:Forgot Password
 */
export const useResetForgotPasswordApiV1AuthForgotPasswordPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>>,
    TError,
    { data: BodyResetForgotPasswordApiV1AuthForgotPasswordPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof resetForgotPasswordApiV1AuthForgotPasswordPost>>,
  TError,
  { data: BodyResetForgotPasswordApiV1AuthForgotPasswordPost },
  TContext
> => {
  const mutationOptions =
    getResetForgotPasswordApiV1AuthForgotPasswordPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Reset:Reset Password
 */
export const resetResetPasswordApiV1AuthResetPasswordPost = (
  bodyResetResetPasswordApiV1AuthResetPasswordPost: BodyResetResetPasswordApiV1AuthResetPasswordPost
) => {
  return platformInstance<unknown>({
    url: `/api/v1/auth/reset-password`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bodyResetResetPasswordApiV1AuthResetPasswordPost
  })
}

export const getResetResetPasswordApiV1AuthResetPasswordPostMutationOptions = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>,
    TError,
    { data: BodyResetResetPasswordApiV1AuthResetPasswordPost },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>,
  TError,
  { data: BodyResetResetPasswordApiV1AuthResetPasswordPost },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>,
    { data: BodyResetResetPasswordApiV1AuthResetPasswordPost }
  > = (props) => {
    const { data } = props ?? {}

    return resetResetPasswordApiV1AuthResetPasswordPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type ResetResetPasswordApiV1AuthResetPasswordPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>
  >
export type ResetResetPasswordApiV1AuthResetPasswordPostMutationBody =
  BodyResetResetPasswordApiV1AuthResetPasswordPost
export type ResetResetPasswordApiV1AuthResetPasswordPostMutationError =
  | ErrorModel
  | HTTPValidationError

/**
 * @summary Reset:Reset Password
 */
export const useResetResetPasswordApiV1AuthResetPasswordPost = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>,
    TError,
    { data: BodyResetResetPasswordApiV1AuthResetPasswordPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof resetResetPasswordApiV1AuthResetPasswordPost>>,
  TError,
  { data: BodyResetResetPasswordApiV1AuthResetPasswordPost },
  TContext
> => {
  const mutationOptions =
    getResetResetPasswordApiV1AuthResetPasswordPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Login
 */
export const loginApiV1AuthLoginPost = (
  bodyLoginApiV1AuthLoginPost: BodyLoginApiV1AuthLoginPost
) => {
  const formUrlEncoded = new URLSearchParams()
  if (bodyLoginApiV1AuthLoginPost.otp_token !== undefined) {
    formUrlEncoded.append('otp_token', bodyLoginApiV1AuthLoginPost.otp_token)
  }
  if (bodyLoginApiV1AuthLoginPost.grant_type !== undefined) {
    formUrlEncoded.append('grant_type', bodyLoginApiV1AuthLoginPost.grant_type)
  }
  formUrlEncoded.append('username', bodyLoginApiV1AuthLoginPost.username)
  formUrlEncoded.append('password', bodyLoginApiV1AuthLoginPost.password)
  if (bodyLoginApiV1AuthLoginPost.scope !== undefined) {
    formUrlEncoded.append('scope', bodyLoginApiV1AuthLoginPost.scope)
  }
  if (bodyLoginApiV1AuthLoginPost.client_id !== undefined) {
    formUrlEncoded.append('client_id', bodyLoginApiV1AuthLoginPost.client_id)
  }
  if (bodyLoginApiV1AuthLoginPost.client_secret !== undefined) {
    formUrlEncoded.append(
      'client_secret',
      bodyLoginApiV1AuthLoginPost.client_secret
    )
  }

  return platformInstance<BearerResponse>({
    url: `/api/v1/auth/login`,
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: formUrlEncoded
  })
}

export const getLoginApiV1AuthLoginPostMutationOptions = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>,
    TError,
    { data: BodyLoginApiV1AuthLoginPost },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>,
  TError,
  { data: BodyLoginApiV1AuthLoginPost },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>,
    { data: BodyLoginApiV1AuthLoginPost }
  > = (props) => {
    const { data } = props ?? {}

    return loginApiV1AuthLoginPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type LoginApiV1AuthLoginPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>
>
export type LoginApiV1AuthLoginPostMutationBody = BodyLoginApiV1AuthLoginPost
export type LoginApiV1AuthLoginPostMutationError =
  | ErrorModel
  | HTTPValidationError

/**
 * @summary Login
 */
export const useLoginApiV1AuthLoginPost = <
  TError = ErrorModel | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>,
    TError,
    { data: BodyLoginApiV1AuthLoginPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof loginApiV1AuthLoginPost>>,
  TError,
  { data: BodyLoginApiV1AuthLoginPost },
  TContext
> => {
  const mutationOptions = getLoginApiV1AuthLoginPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Logout
 */
export const logoutApiV1AuthLogoutPost = () => {
  return platformInstance<unknown>({
    url: `/api/v1/auth/logout`,
    method: 'POST'
  })
}

export const getLogoutApiV1AuthLogoutPostMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>,
    void
  > = () => {
    return logoutApiV1AuthLogoutPost()
  }

  return { mutationFn, ...mutationOptions }
}

export type LogoutApiV1AuthLogoutPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>
>

export type LogoutApiV1AuthLogoutPostMutationError = void | HTTPValidationError

/**
 * @summary Logout
 */
export const useLogoutApiV1AuthLogoutPost = <
  TError = void | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof logoutApiV1AuthLogoutPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getLogoutApiV1AuthLogoutPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Reference
 */
export const getReferenceApiV1ReferencesReferenceTypeAliasGet = (
  referenceType: ReferenceType,
  alias: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetReferenceResponse>({
    url: `/api/v1/references/${referenceType}/${alias}`,
    method: 'GET',
    signal
  })
}

export const getGetReferenceApiV1ReferencesReferenceTypeAliasGetQueryKey = (
  referenceType: ReferenceType,
  alias: string
) => {
  return [`/api/v1/references/${referenceType}/${alias}`] as const
}

export const getGetReferenceApiV1ReferencesReferenceTypeAliasGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>
  >,
  TError = HTTPValidationError
>(
  referenceType: ReferenceType,
  alias: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferenceApiV1ReferencesReferenceTypeAliasGetQueryKey(
      referenceType,
      alias
    )

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>>
  > = ({ signal }) =>
    getReferenceApiV1ReferencesReferenceTypeAliasGet(
      referenceType,
      alias,
      signal
    )

  return {
    queryKey,
    queryFn,
    enabled: !!(referenceType && alias),
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>
    >,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetReferenceApiV1ReferencesReferenceTypeAliasGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>>
  >
export type GetReferenceApiV1ReferencesReferenceTypeAliasGetQueryError =
  HTTPValidationError

/**
 * @summary Get Reference
 */
export const useGetReferenceApiV1ReferencesReferenceTypeAliasGet = <
  TData = Awaited<
    ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>
  >,
  TError = HTTPValidationError
>(
  referenceType: ReferenceType,
  alias: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReferenceApiV1ReferencesReferenceTypeAliasGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetReferenceApiV1ReferencesReferenceTypeAliasGetQueryOptions(
      referenceType,
      alias,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Tags
 */
export const getTagsApiV1ReferencesTagsGet = (signal?: AbortSignal) => {
  return platformInstance<ListReferenceResponse>({
    url: `/api/v1/references/tags`,
    method: 'GET',
    signal
  })
}

export const getGetTagsApiV1ReferencesTagsGetQueryKey = () => {
  return [`/api/v1/references/tags`] as const
}

export const getGetTagsApiV1ReferencesTagsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetTagsApiV1ReferencesTagsGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>
  > = ({ signal }) => getTagsApiV1ReferencesTagsGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetTagsApiV1ReferencesTagsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>
>
export type GetTagsApiV1ReferencesTagsGetQueryError = HTTPValidationError

/**
 * @summary Get Tags
 */
export const useGetTagsApiV1ReferencesTagsGet = <
  TData = Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTagsApiV1ReferencesTagsGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTagsApiV1ReferencesTagsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get References
 */
export const getReferencesApiV1ReferencesReferenceTypeGet = (
  referenceType: string,
  signal?: AbortSignal
) => {
  return platformInstance<ListReferenceResponse>({
    url: `/api/v1/references/${referenceType}`,
    method: 'GET',
    signal
  })
}

export const getGetReferencesApiV1ReferencesReferenceTypeGetQueryKey = (
  referenceType: string
) => {
  return [`/api/v1/references/${referenceType}`] as const
}

export const getGetReferencesApiV1ReferencesReferenceTypeGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>
  >,
  TError = HTTPValidationError
>(
  referenceType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetReferencesApiV1ReferencesReferenceTypeGetQueryKey(referenceType)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>>
  > = ({ signal }) =>
    getReferencesApiV1ReferencesReferenceTypeGet(referenceType, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!referenceType,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetReferencesApiV1ReferencesReferenceTypeGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>>
  >
export type GetReferencesApiV1ReferencesReferenceTypeGetQueryError =
  HTTPValidationError

/**
 * @summary Get References
 */
export const useGetReferencesApiV1ReferencesReferenceTypeGet = <
  TData = Awaited<
    ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>
  >,
  TError = HTTPValidationError
>(
  referenceType: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getReferencesApiV1ReferencesReferenceTypeGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetReferencesApiV1ReferencesReferenceTypeGetQueryOptions(
      referenceType,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Add Value
 */
export const addValueApiV1ReferencesReferenceTypePost = (
  referenceType: ReferenceType,
  addReferenceRequest: AddReferenceRequest
) => {
  return platformInstance<GetReferenceResponse>({
    url: `/api/v1/references/${referenceType}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addReferenceRequest
  })
}

export const getAddValueApiV1ReferencesReferenceTypePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>,
    TError,
    { referenceType: ReferenceType; data: AddReferenceRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>,
  TError,
  { referenceType: ReferenceType; data: AddReferenceRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>,
    { referenceType: ReferenceType; data: AddReferenceRequest }
  > = (props) => {
    const { referenceType, data } = props ?? {}

    return addValueApiV1ReferencesReferenceTypePost(referenceType, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AddValueApiV1ReferencesReferenceTypePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>
  >
export type AddValueApiV1ReferencesReferenceTypePostMutationBody =
  AddReferenceRequest
export type AddValueApiV1ReferencesReferenceTypePostMutationError =
  HTTPValidationError

/**
 * @summary Add Value
 */
export const useAddValueApiV1ReferencesReferenceTypePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>,
    TError,
    { referenceType: ReferenceType; data: AddReferenceRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof addValueApiV1ReferencesReferenceTypePost>>,
  TError,
  { referenceType: ReferenceType; data: AddReferenceRequest },
  TContext
> => {
  const mutationOptions =
    getAddValueApiV1ReferencesReferenceTypePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Tag
 */
export const updateTagApiV1ReferencesTagsTagAliasPatch = (
  tagAlias: string,
  updateReferenceRequest: UpdateReferenceRequest
) => {
  return platformInstance<GetReferenceResponse>({
    url: `/api/v1/references/tags/${tagAlias}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateReferenceRequest
  })
}

export const getUpdateTagApiV1ReferencesTagsTagAliasPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>,
    TError,
    { tagAlias: string; data: UpdateReferenceRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>,
  TError,
  { tagAlias: string; data: UpdateReferenceRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>,
    { tagAlias: string; data: UpdateReferenceRequest }
  > = (props) => {
    const { tagAlias, data } = props ?? {}

    return updateTagApiV1ReferencesTagsTagAliasPatch(tagAlias, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateTagApiV1ReferencesTagsTagAliasPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>
  >
export type UpdateTagApiV1ReferencesTagsTagAliasPatchMutationBody =
  UpdateReferenceRequest
export type UpdateTagApiV1ReferencesTagsTagAliasPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Tag
 */
export const useUpdateTagApiV1ReferencesTagsTagAliasPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>,
    TError,
    { tagAlias: string; data: UpdateReferenceRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTagApiV1ReferencesTagsTagAliasPatch>>,
  TError,
  { tagAlias: string; data: UpdateReferenceRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTagApiV1ReferencesTagsTagAliasPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Delete Tag
 */
export const deleteTagApiV1ReferencesTagsTagAliasDelete = (
  tagAlias: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/references/tags/${tagAlias}`,
    method: 'DELETE'
  })
}

export const getDeleteTagApiV1ReferencesTagsTagAliasDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>,
    TError,
    { tagAlias: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>,
  TError,
  { tagAlias: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>,
    { tagAlias: string }
  > = (props) => {
    const { tagAlias } = props ?? {}

    return deleteTagApiV1ReferencesTagsTagAliasDelete(tagAlias)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteTagApiV1ReferencesTagsTagAliasDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>
  >

export type DeleteTagApiV1ReferencesTagsTagAliasDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Tag
 */
export const useDeleteTagApiV1ReferencesTagsTagAliasDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>,
    TError,
    { tagAlias: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTagApiV1ReferencesTagsTagAliasDelete>>,
  TError,
  { tagAlias: string },
  TContext
> => {
  const mutationOptions =
    getDeleteTagApiV1ReferencesTagsTagAliasDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Value
 */
export const updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch = (
  referenceType: ReferenceType,
  referenceAlias: string,
  updateReferenceRequest: UpdateReferenceRequest
) => {
  return platformInstance<GetReferenceResponse>({
    url: `/api/v1/references/${referenceType}/${referenceAlias}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateReferenceRequest
  })
}

export const getUpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
        >
      >,
      TError,
      {
        referenceType: ReferenceType
        referenceAlias: string
        data: UpdateReferenceRequest
      },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
      >
    >,
    TError,
    {
      referenceType: ReferenceType
      referenceAlias: string
      data: UpdateReferenceRequest
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
        >
      >,
      {
        referenceType: ReferenceType
        referenceAlias: string
        data: UpdateReferenceRequest
      }
    > = (props) => {
      const { referenceType, referenceAlias, data } = props ?? {}

      return updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch(
        referenceType,
        referenceAlias,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
      >
    >
  >
export type UpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatchMutationBody =
  UpdateReferenceRequest
export type UpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Value
 */
export const useUpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
      >
    >,
    TError,
    {
      referenceType: ReferenceType
      referenceAlias: string
      data: UpdateReferenceRequest
    },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateValueApiV1ReferencesReferenceTypeReferenceAliasPatch
    >
  >,
  TError,
  {
    referenceType: ReferenceType
    referenceAlias: string
    data: UpdateReferenceRequest
  },
  TContext
> => {
  const mutationOptions =
    getUpdateValueApiV1ReferencesReferenceTypeReferenceAliasPatchMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Create Profile
 */
export const createProfileApiV1ProfilesPost = (
  createProfileRequest: CreateProfileRequest
) => {
  return platformInstance<GetProfileResponse>({
    url: `/api/v1/profiles/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createProfileRequest
  })
}

export const getCreateProfileApiV1ProfilesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>,
    TError,
    { data: CreateProfileRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>,
  TError,
  { data: CreateProfileRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>,
    { data: CreateProfileRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createProfileApiV1ProfilesPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateProfileApiV1ProfilesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>
>
export type CreateProfileApiV1ProfilesPostMutationBody = CreateProfileRequest
export type CreateProfileApiV1ProfilesPostMutationError = HTTPValidationError

/**
 * @summary Create Profile
 */
export const useCreateProfileApiV1ProfilesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>,
    TError,
    { data: CreateProfileRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createProfileApiV1ProfilesPost>>,
  TError,
  { data: CreateProfileRequest },
  TContext
> => {
  const mutationOptions =
    getCreateProfileApiV1ProfilesPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Users
 */
export const listUsersApiV1UsersGet = (
  params?: ListUsersApiV1UsersGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListUsersResponse>({
    url: `/api/v1/users/`,
    method: 'GET',
    params,
    signal
  })
}

export const getListUsersApiV1UsersGetQueryKey = (
  params?: ListUsersApiV1UsersGetParams
) => {
  return [`/api/v1/users/`, ...(params ? [params] : [])] as const
}

export const getListUsersApiV1UsersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsersApiV1UsersGet>>,
  TError = HTTPValidationError
>(
  params?: ListUsersApiV1UsersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersApiV1UsersGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getListUsersApiV1UsersGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listUsersApiV1UsersGet>>
  > = ({ signal }) => listUsersApiV1UsersGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsersApiV1UsersGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListUsersApiV1UsersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsersApiV1UsersGet>>
>
export type ListUsersApiV1UsersGetQueryError = HTTPValidationError

/**
 * @summary List Users
 */
export const useListUsersApiV1UsersGet = <
  TData = Awaited<ReturnType<typeof listUsersApiV1UsersGet>>,
  TError = HTTPValidationError
>(
  params?: ListUsersApiV1UsersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listUsersApiV1UsersGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListUsersApiV1UsersGetQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Profile
 */
export const getProfileApiV1UsersUserIdProfileGet = (
  userId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetProfileResponse>({
    url: `/api/v1/users/${userId}/profile`,
    method: 'GET',
    signal
  })
}

export const getGetProfileApiV1UsersUserIdProfileGetQueryKey = (
  userId: string
) => {
  return [`/api/v1/users/${userId}/profile`] as const
}

export const getGetProfileApiV1UsersUserIdProfileGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetProfileApiV1UsersUserIdProfileGetQueryKey(userId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>
  > = ({ signal }) => getProfileApiV1UsersUserIdProfileGet(userId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProfileApiV1UsersUserIdProfileGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>
>
export type GetProfileApiV1UsersUserIdProfileGetQueryError = HTTPValidationError

/**
 * @summary Get Profile
 */
export const useGetProfileApiV1UsersUserIdProfileGet = <
  TData = Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProfileApiV1UsersUserIdProfileGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetProfileApiV1UsersUserIdProfileGetQueryOptions(
    userId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update User Profile
 */
export const updateUserProfileApiV1UsersUserIdProfilePatch = (
  userId: string,
  updateProfileRequest: UpdateProfileRequest
) => {
  return platformInstance<GetProfileResponse>({
    url: `/api/v1/users/${userId}/profile`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateProfileRequest
  })
}

export const getUpdateUserProfileApiV1UsersUserIdProfilePatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>,
    TError,
    { userId: string; data: UpdateProfileRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>,
  TError,
  { userId: string; data: UpdateProfileRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>,
    { userId: string; data: UpdateProfileRequest }
  > = (props) => {
    const { userId, data } = props ?? {}

    return updateUserProfileApiV1UsersUserIdProfilePatch(userId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateUserProfileApiV1UsersUserIdProfilePatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>
  >
export type UpdateUserProfileApiV1UsersUserIdProfilePatchMutationBody =
  UpdateProfileRequest
export type UpdateUserProfileApiV1UsersUserIdProfilePatchMutationError =
  HTTPValidationError

/**
 * @summary Update User Profile
 */
export const useUpdateUserProfileApiV1UsersUserIdProfilePatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>,
    TError,
    { userId: string; data: UpdateProfileRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserProfileApiV1UsersUserIdProfilePatch>>,
  TError,
  { userId: string; data: UpdateProfileRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateUserProfileApiV1UsersUserIdProfilePatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Profile
 */
export const getProfileApiV1UsersSelfProfileGet = (
  params: GetProfileApiV1UsersSelfProfileGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<GetProfileResponse>({
    url: `/api/v1/users/self/profile`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetProfileApiV1UsersSelfProfileGetQueryKey = (
  params: GetProfileApiV1UsersSelfProfileGetParams
) => {
  return [`/api/v1/users/self/profile`, ...(params ? [params] : [])] as const
}

export const getGetProfileApiV1UsersSelfProfileGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>,
  TError = HTTPValidationError
>(
  params: GetProfileApiV1UsersSelfProfileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetProfileApiV1UsersSelfProfileGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>
  > = ({ signal }) => getProfileApiV1UsersSelfProfileGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetProfileApiV1UsersSelfProfileGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>
>
export type GetProfileApiV1UsersSelfProfileGetQueryError = HTTPValidationError

/**
 * @summary Get Profile
 */
export const useGetProfileApiV1UsersSelfProfileGet = <
  TData = Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>,
  TError = HTTPValidationError
>(
  params: GetProfileApiV1UsersSelfProfileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProfileApiV1UsersSelfProfileGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetProfileApiV1UsersSelfProfileGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Firebase Auth
 */
export const firebaseAuthApiV1UsersFirebaseLoginPost = (
  firebaseLoginRequest: FirebaseLoginRequest
) => {
  return platformInstance<unknown>({
    url: `/api/v1/users/firebase-login`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: firebaseLoginRequest
  })
}

export const getFirebaseAuthApiV1UsersFirebaseLoginPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>,
    TError,
    { data: FirebaseLoginRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>,
  TError,
  { data: FirebaseLoginRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>,
    { data: FirebaseLoginRequest }
  > = (props) => {
    const { data } = props ?? {}

    return firebaseAuthApiV1UsersFirebaseLoginPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type FirebaseAuthApiV1UsersFirebaseLoginPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>
>
export type FirebaseAuthApiV1UsersFirebaseLoginPostMutationBody =
  FirebaseLoginRequest
export type FirebaseAuthApiV1UsersFirebaseLoginPostMutationError =
  HTTPValidationError

/**
 * @summary Firebase Auth
 */
export const useFirebaseAuthApiV1UsersFirebaseLoginPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>,
    TError,
    { data: FirebaseLoginRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof firebaseAuthApiV1UsersFirebaseLoginPost>>,
  TError,
  { data: FirebaseLoginRequest },
  TContext
> => {
  const mutationOptions =
    getFirebaseAuthApiV1UsersFirebaseLoginPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Current User
 */
export const getCurrentUserApiV1UsersSelfGet = (signal?: AbortSignal) => {
  return platformInstance<UserResponse>({
    url: `/api/v1/users/self`,
    method: 'GET',
    signal
  })
}

export const getGetCurrentUserApiV1UsersSelfGetQueryKey = () => {
  return [`/api/v1/users/self`] as const
}

export const getGetCurrentUserApiV1UsersSelfGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>,
  TError = void | HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrentUserApiV1UsersSelfGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>
  > = ({ signal }) => getCurrentUserApiV1UsersSelfGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetCurrentUserApiV1UsersSelfGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>
>
export type GetCurrentUserApiV1UsersSelfGetQueryError =
  void | HTTPValidationError

/**
 * @summary Get Current User
 */
export const useGetCurrentUserApiV1UsersSelfGet = <
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>,
  TError = void | HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUserApiV1UsersSelfGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCurrentUserApiV1UsersSelfGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Delete Current User
 */
export const deleteCurrentUserApiV1UsersSelfDelete = (
  deleteUserRequest: DeleteUserRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/users/self`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteUserRequest
  })
}

export const getDeleteCurrentUserApiV1UsersSelfDeleteMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>,
    TError,
    { data: DeleteUserRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>,
  TError,
  { data: DeleteUserRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>,
    { data: DeleteUserRequest }
  > = (props) => {
    const { data } = props ?? {}

    return deleteCurrentUserApiV1UsersSelfDelete(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteCurrentUserApiV1UsersSelfDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>
>
export type DeleteCurrentUserApiV1UsersSelfDeleteMutationBody =
  DeleteUserRequest
export type DeleteCurrentUserApiV1UsersSelfDeleteMutationError =
  void | HTTPValidationError

/**
 * @summary Delete Current User
 */
export const useDeleteCurrentUserApiV1UsersSelfDelete = <
  TError = void | HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>,
    TError,
    { data: DeleteUserRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCurrentUserApiV1UsersSelfDelete>>,
  TError,
  { data: DeleteUserRequest },
  TContext
> => {
  const mutationOptions =
    getDeleteCurrentUserApiV1UsersSelfDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update User
 */
export const updateUserApiV1UsersSelfPatch = (userUpdate: UserUpdate) => {
  return platformInstance<UserResponse>({
    url: `/api/v1/users/self`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: userUpdate
  })
}

export const getUpdateUserApiV1UsersSelfPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>,
    TError,
    { data: UserUpdate },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>,
  TError,
  { data: UserUpdate },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>,
    { data: UserUpdate }
  > = (props) => {
    const { data } = props ?? {}

    return updateUserApiV1UsersSelfPatch(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateUserApiV1UsersSelfPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>
>
export type UpdateUserApiV1UsersSelfPatchMutationBody = UserUpdate
export type UpdateUserApiV1UsersSelfPatchMutationError = HTTPValidationError

/**
 * @summary Update User
 */
export const useUpdateUserApiV1UsersSelfPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>,
    TError,
    { data: UserUpdate },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserApiV1UsersSelfPatch>>,
  TError,
  { data: UserUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateUserApiV1UsersSelfPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Anonymous Jwt-Token
 */
export const getAnonymousJwtTokenApiV1UsersAnonymousPost = () => {
  return platformInstance<BearerResponse>({
    url: `/api/v1/users/anonymous`,
    method: 'POST'
  })
}

export const getGetAnonymousJwtTokenApiV1UsersAnonymousPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>,
    void
  > = () => {
    return getAnonymousJwtTokenApiV1UsersAnonymousPost()
  }

  return { mutationFn, ...mutationOptions }
}

export type GetAnonymousJwtTokenApiV1UsersAnonymousPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>
  >

export type GetAnonymousJwtTokenApiV1UsersAnonymousPostMutationError =
  HTTPValidationError

/**
 * @summary Get Anonymous Jwt-Token
 */
export const useGetAnonymousJwtTokenApiV1UsersAnonymousPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof getAnonymousJwtTokenApiV1UsersAnonymousPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getGetAnonymousJwtTokenApiV1UsersAnonymousPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Delete User Pic
 */
export const deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete = (
  userIdOrSelf: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/users/${userIdOrSelf}/profile_pic`,
    method: 'DELETE'
  })
}

export const getDeleteUserPicApiV1UsersUserIdOrSelfProfilePicDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
      >,
      TError,
      { userIdOrSelf: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
    >,
    TError,
    { userIdOrSelf: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
      >,
      { userIdOrSelf: string }
    > = (props) => {
      const { userIdOrSelf } = props ?? {}

      return deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete(userIdOrSelf)
    }

    return { mutationFn, ...mutationOptions }
  }

export type DeleteUserPicApiV1UsersUserIdOrSelfProfilePicDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
    >
  >

export type DeleteUserPicApiV1UsersUserIdOrSelfProfilePicDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete User Pic
 */
export const useDeleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
    >,
    TError,
    { userIdOrSelf: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteUserPicApiV1UsersUserIdOrSelfProfilePicDelete>
  >,
  TError,
  { userIdOrSelf: string },
  TContext
> => {
  const mutationOptions =
    getDeleteUserPicApiV1UsersUserIdOrSelfProfilePicDeleteMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Create Artific
 */
export const createArtificApiV1ExpertsPost = (
  createArtificRequest: CreateArtificRequest
) => {
  return platformInstance<GetExpertResponse>({
    url: `/api/v1/experts/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createArtificRequest
  })
}

export const getCreateArtificApiV1ExpertsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>,
    TError,
    { data: CreateArtificRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>,
  TError,
  { data: CreateArtificRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>,
    { data: CreateArtificRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createArtificApiV1ExpertsPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateArtificApiV1ExpertsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>
>
export type CreateArtificApiV1ExpertsPostMutationBody = CreateArtificRequest
export type CreateArtificApiV1ExpertsPostMutationError = HTTPValidationError

/**
 * @summary Create Artific
 */
export const useCreateArtificApiV1ExpertsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>,
    TError,
    { data: CreateArtificRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createArtificApiV1ExpertsPost>>,
  TError,
  { data: CreateArtificRequest },
  TContext
> => {
  const mutationOptions =
    getCreateArtificApiV1ExpertsPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Artifics
 */
export const listArtificsApiV1ExpertsGet = (
  params?: ListArtificsApiV1ExpertsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListExpertsResponse>({
    url: `/api/v1/experts/`,
    method: 'GET',
    params,
    signal
  })
}

export const getListArtificsApiV1ExpertsGetQueryKey = (
  params?: ListArtificsApiV1ExpertsGetParams
) => {
  return [`/api/v1/experts/`, ...(params ? [params] : [])] as const
}

export const getListArtificsApiV1ExpertsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>,
  TError = HTTPValidationError
>(
  params?: ListArtificsApiV1ExpertsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getListArtificsApiV1ExpertsGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>
  > = ({ signal }) => listArtificsApiV1ExpertsGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListArtificsApiV1ExpertsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>
>
export type ListArtificsApiV1ExpertsGetQueryError = HTTPValidationError

/**
 * @summary List Artifics
 */
export const useListArtificsApiV1ExpertsGet = <
  TData = Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>,
  TError = HTTPValidationError
>(
  params?: ListArtificsApiV1ExpertsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listArtificsApiV1ExpertsGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListArtificsApiV1ExpertsGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Artific
 */
export const updateArtificApiV1ExpertsArtificIdPatch = (
  artificId: string,
  updateArtificRequest: UpdateArtificRequest
) => {
  return platformInstance<GetExpertResponse>({
    url: `/api/v1/experts/${artificId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateArtificRequest
  })
}

export const getUpdateArtificApiV1ExpertsArtificIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>,
    TError,
    { artificId: string; data: UpdateArtificRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>,
  TError,
  { artificId: string; data: UpdateArtificRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>,
    { artificId: string; data: UpdateArtificRequest }
  > = (props) => {
    const { artificId, data } = props ?? {}

    return updateArtificApiV1ExpertsArtificIdPatch(artificId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateArtificApiV1ExpertsArtificIdPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>
>
export type UpdateArtificApiV1ExpertsArtificIdPatchMutationBody =
  UpdateArtificRequest
export type UpdateArtificApiV1ExpertsArtificIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Artific
 */
export const useUpdateArtificApiV1ExpertsArtificIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>,
    TError,
    { artificId: string; data: UpdateArtificRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateArtificApiV1ExpertsArtificIdPatch>>,
  TError,
  { artificId: string; data: UpdateArtificRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateArtificApiV1ExpertsArtificIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Artific
 */
export const getArtificApiV1ExpertsArtificIdGet = (
  artificId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetExpertResponse>({
    url: `/api/v1/experts/${artificId}`,
    method: 'GET',
    signal
  })
}

export const getGetArtificApiV1ExpertsArtificIdGetQueryKey = (
  artificId: string
) => {
  return [`/api/v1/experts/${artificId}`] as const
}

export const getGetArtificApiV1ExpertsArtificIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetArtificApiV1ExpertsArtificIdGetQueryKey(artificId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>
  > = ({ signal }) => getArtificApiV1ExpertsArtificIdGet(artificId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!artificId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetArtificApiV1ExpertsArtificIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>
>
export type GetArtificApiV1ExpertsArtificIdGetQueryError = HTTPValidationError

/**
 * @summary Get Artific
 */
export const useGetArtificApiV1ExpertsArtificIdGet = <
  TData = Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getArtificApiV1ExpertsArtificIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetArtificApiV1ExpertsArtificIdGetQueryOptions(
    artificId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Artific Voices
 */
export const getArtificVoicesApiV1ExpertsArtificIdVoicesGet = (
  artificId: string,
  signal?: AbortSignal
) => {
  return platformInstance<SrcDomainsArtificSchemasGetVoicesResponse>({
    url: `/api/v1/experts/${artificId}/voices`,
    method: 'GET',
    signal
  })
}

export const getGetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryKey = (
  artificId: string
) => {
  return [`/api/v1/experts/${artificId}/voices`] as const
}

export const getGetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryKey(artificId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>>
  > = ({ signal }) =>
    getArtificVoicesApiV1ExpertsArtificIdVoicesGet(artificId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!artificId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>>
  >
export type GetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryError =
  HTTPValidationError

/**
 * @summary Get Artific Voices
 */
export const useGetArtificVoicesApiV1ExpertsArtificIdVoicesGet = <
  TData = Awaited<
    ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getArtificVoicesApiV1ExpertsArtificIdVoicesGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetArtificVoicesApiV1ExpertsArtificIdVoicesGetQueryOptions(
      artificId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Welcome Message
 */
export const getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet = (
  artificId: string,
  signal?: AbortSignal
) => {
  return platformInstance<StringOrNoneResponse>({
    url: `/api/v1/experts/${artificId}/welcome_message`,
    method: 'GET',
    signal
  })
}

export const getGetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryKey =
  (artificId: string) => {
    return [`/api/v1/experts/${artificId}/welcome_message`] as const
  }

export const getGetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet>
    >,
    TError = HTTPValidationError
  >(
    artificId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryKey(
        artificId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet
        >
      >
    > = ({ signal }) =>
      getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet(artificId, signal)

    return {
      queryKey,
      queryFn,
      enabled: !!artificId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet>
    >
  >
export type GetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryError =
  HTTPValidationError

/**
 * @summary Get Welcome Message
 */
export const useGetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet = <
  TData = Awaited<
    ReturnType<typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetWelcomeMessageApiV1ExpertsArtificIdWelcomeMessageGetQueryOptions(
      artificId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Artific Share Videos
 */
export const getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet = (
  artificId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetListFilesResponse>({
    url: `/api/v1/experts/${artificId}/share-videos`,
    method: 'GET',
    signal
  })
}

export const getGetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryKey =
  (artificId: string) => {
    return [`/api/v1/experts/${artificId}/share-videos`] as const
  }

export const getGetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
      >
    >,
    TError = HTTPValidationError
  >(
    artificId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryKey(
        artificId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
        >
      >
    > = ({ signal }) =>
      getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet(
        artificId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!artificId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
      >
    >
  >
export type GetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryError =
  HTTPValidationError

/**
 * @summary Get Artific Share Videos
 */
export const useGetArtificShareVideosApiV1ExpertsArtificIdShareVideosGet = <
  TData = Awaited<
    ReturnType<typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getArtificShareVideosApiV1ExpertsArtificIdShareVideosGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetArtificShareVideosApiV1ExpertsArtificIdShareVideosGetQueryOptions(
      artificId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get File
 */
export const getFileApiV1FilesFileIdGet = (
  fileId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetFileResponse>({
    url: `/api/v1/files/${fileId}`,
    method: 'GET',
    signal
  })
}

export const getGetFileApiV1FilesFileIdGetQueryKey = (fileId: string) => {
  return [`/api/v1/files/${fileId}`] as const
}

export const getGetFileApiV1FilesFileIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>,
  TError = HTTPValidationError
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetFileApiV1FilesFileIdGetQueryKey(fileId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>
  > = ({ signal }) => getFileApiV1FilesFileIdGet(fileId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!fileId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetFileApiV1FilesFileIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>
>
export type GetFileApiV1FilesFileIdGetQueryError = HTTPValidationError

/**
 * @summary Get File
 */
export const useGetFileApiV1FilesFileIdGet = <
  TData = Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>,
  TError = HTTPValidationError
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFileApiV1FilesFileIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetFileApiV1FilesFileIdGetQueryOptions(
    fileId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Save File
 */
export const saveFileApiV1FilesPost = (
  bodySaveFileApiV1FilesPost: BodySaveFileApiV1FilesPost
) => {
  const formData = new FormData()
  formData.append('kind', bodySaveFileApiV1FilesPost.kind)
  if (bodySaveFileApiV1FilesPost.entity_id !== undefined) {
    formData.append('entity_id', bodySaveFileApiV1FilesPost.entity_id)
  }
  if (bodySaveFileApiV1FilesPost.alias !== undefined) {
    formData.append('alias', bodySaveFileApiV1FilesPost.alias)
  }
  formData.append('file', bodySaveFileApiV1FilesPost.file)

  return platformInstance<GetFileResponse>({
    url: `/api/v1/files/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

export const getSaveFileApiV1FilesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFileApiV1FilesPost>>,
    TError,
    { data: BodySaveFileApiV1FilesPost },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveFileApiV1FilesPost>>,
  TError,
  { data: BodySaveFileApiV1FilesPost },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveFileApiV1FilesPost>>,
    { data: BodySaveFileApiV1FilesPost }
  > = (props) => {
    const { data } = props ?? {}

    return saveFileApiV1FilesPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type SaveFileApiV1FilesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveFileApiV1FilesPost>>
>
export type SaveFileApiV1FilesPostMutationBody = BodySaveFileApiV1FilesPost
export type SaveFileApiV1FilesPostMutationError = HTTPValidationError

/**
 * @summary Save File
 */
export const useSaveFileApiV1FilesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveFileApiV1FilesPost>>,
    TError,
    { data: BodySaveFileApiV1FilesPost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof saveFileApiV1FilesPost>>,
  TError,
  { data: BodySaveFileApiV1FilesPost },
  TContext
> => {
  const mutationOptions = getSaveFileApiV1FilesPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Checkout Items
 */
export const listCheckoutItemsApiV1CheckoutsListItemsGet = (
  params?: ListCheckoutItemsApiV1CheckoutsListItemsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListCheckoutItemsResponse>({
    url: `/api/v1/checkouts/list-items`,
    method: 'GET',
    params,
    signal
  })
}

export const getListCheckoutItemsApiV1CheckoutsListItemsGetQueryKey = (
  params?: ListCheckoutItemsApiV1CheckoutsListItemsGetParams
) => {
  return [`/api/v1/checkouts/list-items`, ...(params ? [params] : [])] as const
}

export const getListCheckoutItemsApiV1CheckoutsListItemsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCheckoutItemsApiV1CheckoutsListItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getListCheckoutItemsApiV1CheckoutsListItemsGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>>
  > = ({ signal }) =>
    listCheckoutItemsApiV1CheckoutsListItemsGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListCheckoutItemsApiV1CheckoutsListItemsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>>
  >
export type ListCheckoutItemsApiV1CheckoutsListItemsGetQueryError =
  HTTPValidationError

/**
 * @summary List Checkout Items
 */
export const useListCheckoutItemsApiV1CheckoutsListItemsGet = <
  TData = Awaited<
    ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListCheckoutItemsApiV1CheckoutsListItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCheckoutItemsApiV1CheckoutsListItemsGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListCheckoutItemsApiV1CheckoutsListItemsGetQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Checkout
 */
export const createCheckoutApiV1CheckoutsPost = (
  createCheckoutRequest: CreateCheckoutRequest
) => {
  return platformInstance<GetCheckoutResponse>({
    url: `/api/v1/checkouts/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCheckoutRequest
  })
}

export const getCreateCheckoutApiV1CheckoutsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>,
    TError,
    { data: CreateCheckoutRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>,
  TError,
  { data: CreateCheckoutRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>,
    { data: CreateCheckoutRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createCheckoutApiV1CheckoutsPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCheckoutApiV1CheckoutsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>
>
export type CreateCheckoutApiV1CheckoutsPostMutationBody = CreateCheckoutRequest
export type CreateCheckoutApiV1CheckoutsPostMutationError = HTTPValidationError

/**
 * @summary Create Checkout
 */
export const useCreateCheckoutApiV1CheckoutsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>,
    TError,
    { data: CreateCheckoutRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createCheckoutApiV1CheckoutsPost>>,
  TError,
  { data: CreateCheckoutRequest },
  TContext
> => {
  const mutationOptions =
    getCreateCheckoutApiV1CheckoutsPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Process Checkout
 */
export const processCheckoutApiV1CheckoutsCheckoutIdProcessPost = (
  checkoutId: string
) => {
  return platformInstance<unknown>({
    url: `/api/v1/checkouts/${checkoutId}/process`,
    method: 'POST'
  })
}

export const getProcessCheckoutApiV1CheckoutsCheckoutIdProcessPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
      >,
      TError,
      { checkoutId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
    >,
    TError,
    { checkoutId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
      >,
      { checkoutId: string }
    > = (props) => {
      const { checkoutId } = props ?? {}

      return processCheckoutApiV1CheckoutsCheckoutIdProcessPost(checkoutId)
    }

    return { mutationFn, ...mutationOptions }
  }

export type ProcessCheckoutApiV1CheckoutsCheckoutIdProcessPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
    >
  >

export type ProcessCheckoutApiV1CheckoutsCheckoutIdProcessPostMutationError =
  HTTPValidationError

/**
 * @summary Process Checkout
 */
export const useProcessCheckoutApiV1CheckoutsCheckoutIdProcessPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
    >,
    TError,
    { checkoutId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof processCheckoutApiV1CheckoutsCheckoutIdProcessPost>
  >,
  TError,
  { checkoutId: string },
  TContext
> => {
  const mutationOptions =
    getProcessCheckoutApiV1CheckoutsCheckoutIdProcessPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Submit Generation
 */
export const submitGenerationApiV1InferenceSubmitGenerationPost = (
  submitGenerationRequest: SubmitGenerationRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/inference/submit-generation`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: submitGenerationRequest
  })
}

export const getSubmitGenerationApiV1InferenceSubmitGenerationPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
      >,
      TError,
      { data: SubmitGenerationRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
    >,
    TError,
    { data: SubmitGenerationRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
      >,
      { data: SubmitGenerationRequest }
    > = (props) => {
      const { data } = props ?? {}

      return submitGenerationApiV1InferenceSubmitGenerationPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type SubmitGenerationApiV1InferenceSubmitGenerationPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
    >
  >
export type SubmitGenerationApiV1InferenceSubmitGenerationPostMutationBody =
  SubmitGenerationRequest
export type SubmitGenerationApiV1InferenceSubmitGenerationPostMutationError =
  HTTPValidationError

/**
 * @summary Submit Generation
 */
export const useSubmitGenerationApiV1InferenceSubmitGenerationPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
    >,
    TError,
    { data: SubmitGenerationRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof submitGenerationApiV1InferenceSubmitGenerationPost>
  >,
  TError,
  { data: SubmitGenerationRequest },
  TContext
> => {
  const mutationOptions =
    getSubmitGenerationApiV1InferenceSubmitGenerationPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Generate Interview Stream
 */
export const generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost =
  (generateInterviewStreamRequest: GenerateInterviewStreamRequest) => {
    return platformInstance<unknown>({
      url: `/api/v1/inference/generate_interview_stream`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateInterviewStreamRequest
    })
  }

export const getGenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
        >
      >,
      TError,
      { data: GenerateInterviewStreamRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
      >
    >,
    TError,
    { data: GenerateInterviewStreamRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
        >
      >,
      { data: GenerateInterviewStreamRequest }
    > = (props) => {
      const { data } = props ?? {}

      return generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost(
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type GenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
      >
    >
  >
export type GenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPostMutationBody =
  GenerateInterviewStreamRequest
export type GenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPostMutationError =
  HTTPValidationError

/**
 * @summary Generate Interview Stream
 */
export const useGenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
        >
      >,
      TError,
      { data: GenerateInterviewStreamRequest },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateInterviewStreamApiV1InferenceGenerateInterviewStreamPost
      >
    >,
    TError,
    { data: GenerateInterviewStreamRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateInterviewStreamApiV1InferenceGenerateInterviewStreamPostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Generate Welcome Back
 */
export const generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost = (
  generateWelcomeBackRequest: GenerateWelcomeBackRequest
) => {
  return platformInstance<unknown>({
    url: `/api/v1/inference/generate_welcome_back`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generateWelcomeBackRequest
  })
}

export const getGenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost
        >
      >,
      TError,
      { data: GenerateWelcomeBackRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost
      >
    >,
    TError,
    { data: GenerateWelcomeBackRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost
        >
      >,
      { data: GenerateWelcomeBackRequest }
    > = (props) => {
      const { data } = props ?? {}

      return generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type GenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost
      >
    >
  >
export type GenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPostMutationBody =
  GenerateWelcomeBackRequest
export type GenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPostMutationError =
  HTTPValidationError

/**
 * @summary Generate Welcome Back
 */
export const useGenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost
      >
    >,
    TError,
    { data: GenerateWelcomeBackRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof generateWelcomeBackApiV1InferenceGenerateWelcomeBackPost>
  >,
  TError,
  { data: GenerateWelcomeBackRequest },
  TContext
> => {
  const mutationOptions =
    getGenerateWelcomeBackApiV1InferenceGenerateWelcomeBackPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Update Message
 */
export const updateMessageApiV1HistoryMessagesMessageIdPatch = (
  messageId: string,
  updateMessageRequest: UpdateMessageRequest
) => {
  return platformInstance<MessageResponse>({
    url: `/api/v1/history/messages/${messageId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateMessageRequest
  })
}

export const getUpdateMessageApiV1HistoryMessagesMessageIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>
      >,
      TError,
      { messageId: string; data: UpdateMessageRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>>,
    TError,
    { messageId: string; data: UpdateMessageRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>
      >,
      { messageId: string; data: UpdateMessageRequest }
    > = (props) => {
      const { messageId, data } = props ?? {}

      return updateMessageApiV1HistoryMessagesMessageIdPatch(messageId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateMessageApiV1HistoryMessagesMessageIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>>
  >
export type UpdateMessageApiV1HistoryMessagesMessageIdPatchMutationBody =
  UpdateMessageRequest
export type UpdateMessageApiV1HistoryMessagesMessageIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Message
 */
export const useUpdateMessageApiV1HistoryMessagesMessageIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>>,
    TError,
    { messageId: string; data: UpdateMessageRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMessageApiV1HistoryMessagesMessageIdPatch>>,
  TError,
  { messageId: string; data: UpdateMessageRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateMessageApiV1HistoryMessagesMessageIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get History
 */
export const getHistoryApiV1HistoryArtificIdMessagesGet = (
  artificId: string,
  params?: GetHistoryApiV1HistoryArtificIdMessagesGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListMessagesResponse>({
    url: `/api/v1/history/${artificId}/messages`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetHistoryApiV1HistoryArtificIdMessagesGetQueryKey = (
  artificId: string,
  params?: GetHistoryApiV1HistoryArtificIdMessagesGetParams
) => {
  return [
    `/api/v1/history/${artificId}/messages`,
    ...(params ? [params] : [])
  ] as const
}

export const getGetHistoryApiV1HistoryArtificIdMessagesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  params?: GetHistoryApiV1HistoryArtificIdMessagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetHistoryApiV1HistoryArtificIdMessagesGetQueryKey(artificId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>>
  > = ({ signal }) =>
    getHistoryApiV1HistoryArtificIdMessagesGet(artificId, params, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!artificId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetHistoryApiV1HistoryArtificIdMessagesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>>
>
export type GetHistoryApiV1HistoryArtificIdMessagesGetQueryError =
  HTTPValidationError

/**
 * @summary Get History
 */
export const useGetHistoryApiV1HistoryArtificIdMessagesGet = <
  TData = Awaited<
    ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>
  >,
  TError = HTTPValidationError
>(
  artificId: string,
  params?: GetHistoryApiV1HistoryArtificIdMessagesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHistoryApiV1HistoryArtificIdMessagesGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetHistoryApiV1HistoryArtificIdMessagesGetQueryOptions(
      artificId,
      params,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Push Delivery
 */
export const getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet = (
  pushDeliveryId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetPushDeliveryResponse>({
    url: `/api/v1/push/deliveries/${pushDeliveryId}`,
    method: 'GET',
    signal
  })
}

export const getGetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryKey = (
  pushDeliveryId: string
) => {
  return [`/api/v1/push/deliveries/${pushDeliveryId}`] as const
}

export const getGetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
    >,
    TError = HTTPValidationError
  >(
    pushDeliveryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryKey(
        pushDeliveryId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
      >
    > = ({ signal }) =>
      getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet(
        pushDeliveryId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!pushDeliveryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
    >
  >
export type GetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryError =
  HTTPValidationError

/**
 * @summary Get Push Delivery
 */
export const useGetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet = <
  TData = Awaited<
    ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
  >,
  TError = HTTPValidationError
>(
  pushDeliveryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPushDeliveryApiV1PushDeliveriesPushDeliveryIdGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetPushDeliveryApiV1PushDeliveriesPushDeliveryIdGetQueryOptions(
      pushDeliveryId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Push Delivery
 */
export const updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch = (
  pushDeliveryId: string,
  pushDeliveryUpdate: PushDeliveryUpdate
) => {
  return platformInstance<GetPushDeliveryResponse>({
    url: `/api/v1/push/deliveries/${pushDeliveryId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: pushDeliveryUpdate
  })
}

export const getUpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch
        >
      >,
      TError,
      { pushDeliveryId: string; data: PushDeliveryUpdate },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch
      >
    >,
    TError,
    { pushDeliveryId: string; data: PushDeliveryUpdate },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch
        >
      >,
      { pushDeliveryId: string; data: PushDeliveryUpdate }
    > = (props) => {
      const { pushDeliveryId, data } = props ?? {}

      return updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch(
        pushDeliveryId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch
      >
    >
  >
export type UpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatchMutationBody =
  PushDeliveryUpdate
export type UpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Push Delivery
 */
export const useUpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch
      >
    >,
    TError,
    { pushDeliveryId: string; data: PushDeliveryUpdate },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof updatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatch>
  >,
  TError,
  { pushDeliveryId: string; data: PushDeliveryUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdatePushDeliveryApiV1PushDeliveriesPushDeliveryIdPatchMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Delete Push Delivery
 */
export const deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete = (
  pushDeliveryId: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/push/deliveries/${pushDeliveryId}`,
    method: 'DELETE'
  })
}

export const getDeletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete
        >
      >,
      TError,
      { pushDeliveryId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete
      >
    >,
    TError,
    { pushDeliveryId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete
        >
      >,
      { pushDeliveryId: string }
    > = (props) => {
      const { pushDeliveryId } = props ?? {}

      return deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete(
        pushDeliveryId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type DeletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete
      >
    >
  >

export type DeletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Push Delivery
 */
export const useDeletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete
      >
    >,
    TError,
    { pushDeliveryId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof deletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDelete>
  >,
  TError,
  { pushDeliveryId: string },
  TContext
> => {
  const mutationOptions =
    getDeletePushDeliveryApiV1PushDeliveriesPushDeliveryIdDeleteMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary List Push Deliveries
 */
export const listPushDeliveriesApiV1PushDeliveriesGet = (
  params?: ListPushDeliveriesApiV1PushDeliveriesGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListPushDeliveriesResponse>({
    url: `/api/v1/push/deliveries`,
    method: 'GET',
    params,
    signal
  })
}

export const getListPushDeliveriesApiV1PushDeliveriesGetQueryKey = (
  params?: ListPushDeliveriesApiV1PushDeliveriesGetParams
) => {
  return [`/api/v1/push/deliveries`, ...(params ? [params] : [])] as const
}

export const getListPushDeliveriesApiV1PushDeliveriesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPushDeliveriesApiV1PushDeliveriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getListPushDeliveriesApiV1PushDeliveriesGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>
  > = ({ signal }) => listPushDeliveriesApiV1PushDeliveriesGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListPushDeliveriesApiV1PushDeliveriesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>
>
export type ListPushDeliveriesApiV1PushDeliveriesGetQueryError =
  HTTPValidationError

/**
 * @summary List Push Deliveries
 */
export const useListPushDeliveriesApiV1PushDeliveriesGet = <
  TData = Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>,
  TError = HTTPValidationError
>(
  params?: ListPushDeliveriesApiV1PushDeliveriesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPushDeliveriesApiV1PushDeliveriesGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListPushDeliveriesApiV1PushDeliveriesGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Push Delivery
 */
export const createPushDeliveryApiV1PushDeliveriesPost = (
  pushDeliveryCreate: PushDeliveryCreate
) => {
  return platformInstance<GetPushDeliveryResponse>({
    url: `/api/v1/push/deliveries`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: pushDeliveryCreate
  })
}

export const getCreatePushDeliveryApiV1PushDeliveriesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>,
    TError,
    { data: PushDeliveryCreate },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>,
  TError,
  { data: PushDeliveryCreate },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>,
    { data: PushDeliveryCreate }
  > = (props) => {
    const { data } = props ?? {}

    return createPushDeliveryApiV1PushDeliveriesPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreatePushDeliveryApiV1PushDeliveriesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>
  >
export type CreatePushDeliveryApiV1PushDeliveriesPostMutationBody =
  PushDeliveryCreate
export type CreatePushDeliveryApiV1PushDeliveriesPostMutationError =
  HTTPValidationError

/**
 * @summary Create Push Delivery
 */
export const useCreatePushDeliveryApiV1PushDeliveriesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>,
    TError,
    { data: PushDeliveryCreate },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createPushDeliveryApiV1PushDeliveriesPost>>,
  TError,
  { data: PushDeliveryCreate },
  TContext
> => {
  const mutationOptions =
    getCreatePushDeliveryApiV1PushDeliveriesPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Send Single Push
 */
export const sendSinglePushApiV1PushSendPost = (
  sendSinglePushRequest: SendSinglePushRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/push/send`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sendSinglePushRequest
  })
}

export const getSendSinglePushApiV1PushSendPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>,
    TError,
    { data: SendSinglePushRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>,
  TError,
  { data: SendSinglePushRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>,
    { data: SendSinglePushRequest }
  > = (props) => {
    const { data } = props ?? {}

    return sendSinglePushApiV1PushSendPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type SendSinglePushApiV1PushSendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>
>
export type SendSinglePushApiV1PushSendPostMutationBody = SendSinglePushRequest
export type SendSinglePushApiV1PushSendPostMutationError = HTTPValidationError

/**
 * @summary Send Single Push
 */
export const useSendSinglePushApiV1PushSendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>,
    TError,
    { data: SendSinglePushRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof sendSinglePushApiV1PushSendPost>>,
  TError,
  { data: SendSinglePushRequest },
  TContext
> => {
  const mutationOptions =
    getSendSinglePushApiV1PushSendPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Interviews
 */
export const listInterviewsApiV1InterviewsResultsGet = (
  params?: ListInterviewsApiV1InterviewsResultsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListInterviewResultsResponse>({
    url: `/api/v1/interviews/results`,
    method: 'GET',
    params,
    signal
  })
}

export const getListInterviewsApiV1InterviewsResultsGetQueryKey = (
  params?: ListInterviewsApiV1InterviewsResultsGetParams
) => {
  return [`/api/v1/interviews/results`, ...(params ? [params] : [])] as const
}

export const getListInterviewsApiV1InterviewsResultsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>,
  TError = HTTPValidationError
>(
  params?: ListInterviewsApiV1InterviewsResultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getListInterviewsApiV1InterviewsResultsGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>
  > = ({ signal }) => listInterviewsApiV1InterviewsResultsGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListInterviewsApiV1InterviewsResultsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>
>
export type ListInterviewsApiV1InterviewsResultsGetQueryError =
  HTTPValidationError

/**
 * @summary List Interviews
 */
export const useListInterviewsApiV1InterviewsResultsGet = <
  TData = Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>,
  TError = HTTPValidationError
>(
  params?: ListInterviewsApiV1InterviewsResultsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInterviewsApiV1InterviewsResultsGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListInterviewsApiV1InterviewsResultsGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Interview
 */
export const updateInterviewApiV1InterviewsInterviewIdPatch = (
  interviewId: string,
  updateInterviewRequest: UpdateInterviewRequest
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/${interviewId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateInterviewRequest
  })
}

export const getUpdateInterviewApiV1InterviewsInterviewIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>
      >,
      TError,
      { interviewId: string; data: UpdateInterviewRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>>,
    TError,
    { interviewId: string; data: UpdateInterviewRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>
      >,
      { interviewId: string; data: UpdateInterviewRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return updateInterviewApiV1InterviewsInterviewIdPatch(interviewId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateInterviewApiV1InterviewsInterviewIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>>
  >
export type UpdateInterviewApiV1InterviewsInterviewIdPatchMutationBody =
  UpdateInterviewRequest
export type UpdateInterviewApiV1InterviewsInterviewIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Interview
 */
export const useUpdateInterviewApiV1InterviewsInterviewIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>>,
    TError,
    { interviewId: string; data: UpdateInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInterviewApiV1InterviewsInterviewIdPatch>>,
  TError,
  { interviewId: string; data: UpdateInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateInterviewApiV1InterviewsInterviewIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Delete Interview
 */
export const deleteInterviewApiV1InterviewsInterviewIdDelete = (
  interviewId: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}`,
    method: 'DELETE'
  })
}

export const getDeleteInterviewApiV1InterviewsInterviewIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>>,
    TError,
    { interviewId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {}

      return deleteInterviewApiV1InterviewsInterviewIdDelete(interviewId)
    }

    return { mutationFn, ...mutationOptions }
  }

export type DeleteInterviewApiV1InterviewsInterviewIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>>
  >

export type DeleteInterviewApiV1InterviewsInterviewIdDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Interview
 */
export const useDeleteInterviewApiV1InterviewsInterviewIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>>,
    TError,
    { interviewId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInterviewApiV1InterviewsInterviewIdDelete>>,
  TError,
  { interviewId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteInterviewApiV1InterviewsInterviewIdDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Interview
 */
export const getInterviewApiV1InterviewsInterviewIdGet = (
  interviewId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/${interviewId}`,
    method: 'GET',
    signal
  })
}

export const getGetInterviewApiV1InterviewsInterviewIdGetQueryKey = (
  interviewId: string
) => {
  return [`/api/v1/interviews/${interviewId}`] as const
}

export const getGetInterviewApiV1InterviewsInterviewIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetInterviewApiV1InterviewsInterviewIdGetQueryKey(interviewId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>
  > = ({ signal }) =>
    getInterviewApiV1InterviewsInterviewIdGet(interviewId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!interviewId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetInterviewApiV1InterviewsInterviewIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>
>
export type GetInterviewApiV1InterviewsInterviewIdGetQueryError =
  HTTPValidationError

/**
 * @summary Get Interview
 */
export const useGetInterviewApiV1InterviewsInterviewIdGet = <
  TData = Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInterviewApiV1InterviewsInterviewIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInterviewApiV1InterviewsInterviewIdGetQueryOptions(
    interviewId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Duration Tick
 */
export const durationTickApiV1InterviewsInterviewIdDurationTickPost = (
  interviewId: string,
  durationTickRequest: DurationTickRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}/duration-tick`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: durationTickRequest
  })
}

export const getDurationTickApiV1InterviewsInterviewIdDurationTickPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof durationTickApiV1InterviewsInterviewIdDurationTickPost
        >
      >,
      TError,
      { interviewId: string; data: DurationTickRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof durationTickApiV1InterviewsInterviewIdDurationTickPost>
    >,
    TError,
    { interviewId: string; data: DurationTickRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof durationTickApiV1InterviewsInterviewIdDurationTickPost
        >
      >,
      { interviewId: string; data: DurationTickRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return durationTickApiV1InterviewsInterviewIdDurationTickPost(
        interviewId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type DurationTickApiV1InterviewsInterviewIdDurationTickPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof durationTickApiV1InterviewsInterviewIdDurationTickPost>
    >
  >
export type DurationTickApiV1InterviewsInterviewIdDurationTickPostMutationBody =
  DurationTickRequest
export type DurationTickApiV1InterviewsInterviewIdDurationTickPostMutationError =
  HTTPValidationError

/**
 * @summary Duration Tick
 */
export const useDurationTickApiV1InterviewsInterviewIdDurationTickPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof durationTickApiV1InterviewsInterviewIdDurationTickPost>
    >,
    TError,
    { interviewId: string; data: DurationTickRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof durationTickApiV1InterviewsInterviewIdDurationTickPost>
  >,
  TError,
  { interviewId: string; data: DurationTickRequest },
  TContext
> => {
  const mutationOptions =
    getDurationTickApiV1InterviewsInterviewIdDurationTickPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Permissions
 */
export const permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost = (
  interviewId: string
) => {
  return platformInstance<unknown>({
    url: `/api/v1/interviews/${interviewId}/set-permissions-status`,
    method: 'POST'
  })
}

export const getPermissionsApiV1InterviewsInterviewIdSetPermissionsStatusPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
        >
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {}

      return permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost(
        interviewId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type PermissionsApiV1InterviewsInterviewIdSetPermissionsStatusPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
      >
    >
  >

export type PermissionsApiV1InterviewsInterviewIdSetPermissionsStatusPostMutationError =
  HTTPValidationError

/**
 * @summary Permissions
 */
export const usePermissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof permissionsApiV1InterviewsInterviewIdSetPermissionsStatusPost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationOptions =
      getPermissionsApiV1InterviewsInterviewIdSetPermissionsStatusPostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Delete Interviews Batch
 */
export const deleteInterviewsBatchApiV1InterviewsDelete = (
  batchInterviewRequest: BatchInterviewRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: batchInterviewRequest
  })
}

export const getDeleteInterviewsBatchApiV1InterviewsDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>,
    TError,
    { data: BatchInterviewRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>,
  TError,
  { data: BatchInterviewRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>,
    { data: BatchInterviewRequest }
  > = (props) => {
    const { data } = props ?? {}

    return deleteInterviewsBatchApiV1InterviewsDelete(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteInterviewsBatchApiV1InterviewsDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>
  >
export type DeleteInterviewsBatchApiV1InterviewsDeleteMutationBody =
  BatchInterviewRequest
export type DeleteInterviewsBatchApiV1InterviewsDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Interviews Batch
 */
export const useDeleteInterviewsBatchApiV1InterviewsDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>,
    TError,
    { data: BatchInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteInterviewsBatchApiV1InterviewsDelete>>,
  TError,
  { data: BatchInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getDeleteInterviewsBatchApiV1InterviewsDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Create Interview
 */
export const createInterviewApiV1InterviewsPost = (
  createInterviewRequest: CreateInterviewRequest
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInterviewRequest
  })
}

export const getCreateInterviewApiV1InterviewsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>,
    { data: CreateInterviewRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createInterviewApiV1InterviewsPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateInterviewApiV1InterviewsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>
>
export type CreateInterviewApiV1InterviewsPostMutationBody =
  CreateInterviewRequest
export type CreateInterviewApiV1InterviewsPostMutationError =
  HTTPValidationError

/**
 * @summary Create Interview
 */
export const useCreateInterviewApiV1InterviewsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createInterviewApiV1InterviewsPost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getCreateInterviewApiV1InterviewsPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Undelete Interview
 */
export const undeleteInterviewApiV1InterviewsInterviewIdUndeletePost = (
  interviewId: string
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/${interviewId}/undelete`,
    method: 'POST'
  })
}

export const getUndeleteInterviewApiV1InterviewsInterviewIdUndeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost>
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost
        >
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {}

      return undeleteInterviewApiV1InterviewsInterviewIdUndeletePost(
        interviewId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UndeleteInterviewApiV1InterviewsInterviewIdUndeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost>
    >
  >

export type UndeleteInterviewApiV1InterviewsInterviewIdUndeletePostMutationError =
  HTTPValidationError

/**
 * @summary Undelete Interview
 */
export const useUndeleteInterviewApiV1InterviewsInterviewIdUndeletePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost>
    >,
    TError,
    { interviewId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof undeleteInterviewApiV1InterviewsInterviewIdUndeletePost>
  >,
  TError,
  { interviewId: string },
  TContext
> => {
  const mutationOptions =
    getUndeleteInterviewApiV1InterviewsInterviewIdUndeletePostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Undelete Interviews Batch
 */
export const undeleteInterviewsBatchApiV1InterviewsUndeletePost = (
  batchInterviewRequest: BatchInterviewRequest
) => {
  return platformInstance<ListInterviewResultsResponse>({
    url: `/api/v1/interviews/undelete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: batchInterviewRequest
  })
}

export const getUndeleteInterviewsBatchApiV1InterviewsUndeletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
      >,
      TError,
      { data: BatchInterviewRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
    >,
    TError,
    { data: BatchInterviewRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
      >,
      { data: BatchInterviewRequest }
    > = (props) => {
      const { data } = props ?? {}

      return undeleteInterviewsBatchApiV1InterviewsUndeletePost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type UndeleteInterviewsBatchApiV1InterviewsUndeletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
    >
  >
export type UndeleteInterviewsBatchApiV1InterviewsUndeletePostMutationBody =
  BatchInterviewRequest
export type UndeleteInterviewsBatchApiV1InterviewsUndeletePostMutationError =
  HTTPValidationError

/**
 * @summary Undelete Interviews Batch
 */
export const useUndeleteInterviewsBatchApiV1InterviewsUndeletePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
    >,
    TError,
    { data: BatchInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof undeleteInterviewsBatchApiV1InterviewsUndeletePost>
  >,
  TError,
  { data: BatchInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getUndeleteInterviewsBatchApiV1InterviewsUndeletePostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Ensure Interview
 */
export const ensureInterviewApiV1InterviewsEnsurePost = (
  createInterviewRequest: CreateInterviewRequest
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/ensure`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInterviewRequest
  })
}

export const getEnsureInterviewApiV1InterviewsEnsurePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>,
    { data: CreateInterviewRequest }
  > = (props) => {
    const { data } = props ?? {}

    return ensureInterviewApiV1InterviewsEnsurePost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type EnsureInterviewApiV1InterviewsEnsurePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>
  >
export type EnsureInterviewApiV1InterviewsEnsurePostMutationBody =
  CreateInterviewRequest
export type EnsureInterviewApiV1InterviewsEnsurePostMutationError =
  HTTPValidationError

/**
 * @summary Ensure Interview
 */
export const useEnsureInterviewApiV1InterviewsEnsurePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof ensureInterviewApiV1InterviewsEnsurePost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getEnsureInterviewApiV1InterviewsEnsurePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Submit Forms
 */
export const submitFormsApiV1InterviewsInterviewIdSubmitFormsPost = (
  interviewId: string,
  sumbitFormsRequest: SumbitFormsRequest
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/interviews/${interviewId}/submit_forms`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sumbitFormsRequest
  })
}

export const getSubmitFormsApiV1InterviewsInterviewIdSubmitFormsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
      >,
      TError,
      { interviewId: string; data: SumbitFormsRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
    >,
    TError,
    { interviewId: string; data: SumbitFormsRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
      >,
      { interviewId: string; data: SumbitFormsRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return submitFormsApiV1InterviewsInterviewIdSubmitFormsPost(
        interviewId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type SubmitFormsApiV1InterviewsInterviewIdSubmitFormsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
    >
  >
export type SubmitFormsApiV1InterviewsInterviewIdSubmitFormsPostMutationBody =
  SumbitFormsRequest
export type SubmitFormsApiV1InterviewsInterviewIdSubmitFormsPostMutationError =
  HTTPValidationError

/**
 * @summary Submit Forms
 */
export const useSubmitFormsApiV1InterviewsInterviewIdSubmitFormsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
    >,
    TError,
    { interviewId: string; data: SumbitFormsRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof submitFormsApiV1InterviewsInterviewIdSubmitFormsPost>
  >,
  TError,
  { interviewId: string; data: SumbitFormsRequest },
  TContext
> => {
  const mutationOptions =
    getSubmitFormsApiV1InterviewsInterviewIdSubmitFormsPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Evaluate
 */
export const evaluateApiV1InterviewsInterviewIdEvaluatePost = (
  interviewId: string,
  evaluateInterviewRequest: EvaluateInterviewRequest
) => {
  return platformInstance<GetInterviewEvaluationResponse>({
    url: `/api/v1/interviews/${interviewId}/evaluate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: evaluateInterviewRequest
  })
}

export const getEvaluateApiV1InterviewsInterviewIdEvaluatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>
      >,
      TError,
      { interviewId: string; data: EvaluateInterviewRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>>,
    TError,
    { interviewId: string; data: EvaluateInterviewRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>
      >,
      { interviewId: string; data: EvaluateInterviewRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return evaluateApiV1InterviewsInterviewIdEvaluatePost(interviewId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type EvaluateApiV1InterviewsInterviewIdEvaluatePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>>
  >
export type EvaluateApiV1InterviewsInterviewIdEvaluatePostMutationBody =
  EvaluateInterviewRequest
export type EvaluateApiV1InterviewsInterviewIdEvaluatePostMutationError =
  HTTPValidationError

/**
 * @summary Evaluate
 */
export const useEvaluateApiV1InterviewsInterviewIdEvaluatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>>,
    TError,
    { interviewId: string; data: EvaluateInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof evaluateApiV1InterviewsInterviewIdEvaluatePost>>,
  TError,
  { interviewId: string; data: EvaluateInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getEvaluateApiV1InterviewsInterviewIdEvaluatePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Evaluation
 */
export const getEvaluationApiV1InterviewsInterviewIdEvaluationGet = (
  interviewId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetInterviewEvaluationResponse>({
    url: `/api/v1/interviews/${interviewId}/evaluation`,
    method: 'GET',
    signal
  })
}

export const getGetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryKey = (
  interviewId: string
) => {
  return [`/api/v1/interviews/${interviewId}/evaluation`] as const
}

export const getGetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet>
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryKey(
        interviewId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet>
      >
    > = ({ signal }) =>
      getEvaluationApiV1InterviewsInterviewIdEvaluationGet(interviewId, signal)

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet>
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet>
    >
  >
export type GetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryError =
  HTTPValidationError

/**
 * @summary Get Evaluation
 */
export const useGetEvaluationApiV1InterviewsInterviewIdEvaluationGet = <
  TData = Awaited<
    ReturnType<typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEvaluationApiV1InterviewsInterviewIdEvaluationGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetEvaluationApiV1InterviewsInterviewIdEvaluationGetQueryOptions(
      interviewId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Interview Details
 */
export const getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet = (
  interviewId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetInterviewDetailsResponse>({
    url: `/api/v1/interviews/${interviewId}/details`,
    method: 'GET',
    signal
  })
}

export const getGetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryKey =
  (interviewId: string) => {
    return [`/api/v1/interviews/${interviewId}/details`] as const
  }

export const getGetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet>
    >,
    TError = HTTPValidationError
  >(
    interviewId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryKey(
        interviewId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet
        >
      >
    > = ({ signal }) =>
      getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet(
        interviewId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!interviewId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet>
    >
  >
export type GetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryError =
  HTTPValidationError

/**
 * @summary Get Interview Details
 */
export const useGetInterviewDetailsApiV1InterviewsInterviewIdDetailsGet = <
  TData = Awaited<
    ReturnType<typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet>
  >,
  TError = HTTPValidationError
>(
  interviewId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInterviewDetailsApiV1InterviewsInterviewIdDetailsGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetInterviewDetailsApiV1InterviewsInterviewIdDetailsGetQueryOptions(
      interviewId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Upload Video Chunk
 */
export const uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost = (
  interviewId: string,
  bodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
) => {
  const formData = new FormData()
  formData.append(
    'file',
    bodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost.file
  )

  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}/upload_video_chunk`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

export const getUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
        >
      >,
      TError,
      {
        interviewId: string
        data: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      >
    >,
    TError,
    {
      interviewId: string
      data: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
        >
      >,
      {
        interviewId: string
        data: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost(
        interviewId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      >
    >
  >
export type UploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPostMutationBody =
  BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
export type UploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPostMutationError =
  HTTPValidationError

/**
 * @summary Upload Video Chunk
 */
export const useUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
        >
      >,
      TError,
      {
        interviewId: string
        data: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof uploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
      >
    >,
    TError,
    {
      interviewId: string
      data: BodyUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPost
    },
    TContext
  > => {
    const mutationOptions =
      getUploadVideoChunkApiV1InterviewsInterviewIdUploadVideoChunkPostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Reset History
 */
export const resetHistoryApiV1InterviewsInterviewIdMessagesDelete = (
  interviewId: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}/messages`,
    method: 'DELETE'
  })
}

export const getResetHistoryApiV1InterviewsInterviewIdMessagesDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {}

      return resetHistoryApiV1InterviewsInterviewIdMessagesDelete(interviewId)
    }

    return { mutationFn, ...mutationOptions }
  }

export type ResetHistoryApiV1InterviewsInterviewIdMessagesDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
    >
  >

export type ResetHistoryApiV1InterviewsInterviewIdMessagesDeleteMutationError =
  HTTPValidationError

/**
 * @summary Reset History
 */
export const useResetHistoryApiV1InterviewsInterviewIdMessagesDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
    >,
    TError,
    { interviewId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof resetHistoryApiV1InterviewsInterviewIdMessagesDelete>
  >,
  TError,
  { interviewId: string },
  TContext
> => {
  const mutationOptions =
    getResetHistoryApiV1InterviewsInterviewIdMessagesDeleteMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Append Interview Cost
 */
export const appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost = (
  interviewId: string,
  appendCostRequest: AppendCostRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}/append_cost`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: appendCostRequest
  })
}

export const getAppendInterviewCostApiV1InterviewsInterviewIdAppendCostPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
        >
      >,
      TError,
      { interviewId: string; data: AppendCostRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
      >
    >,
    TError,
    { interviewId: string; data: AppendCostRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
        >
      >,
      { interviewId: string; data: AppendCostRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost(
        interviewId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type AppendInterviewCostApiV1InterviewsInterviewIdAppendCostPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
      >
    >
  >
export type AppendInterviewCostApiV1InterviewsInterviewIdAppendCostPostMutationBody =
  AppendCostRequest
export type AppendInterviewCostApiV1InterviewsInterviewIdAppendCostPostMutationError =
  HTTPValidationError

/**
 * @summary Append Interview Cost
 */
export const useAppendInterviewCostApiV1InterviewsInterviewIdAppendCostPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
      >
    >,
    TError,
    { interviewId: string; data: AppendCostRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof appendInterviewCostApiV1InterviewsInterviewIdAppendCostPost
    >
  >,
  TError,
  { interviewId: string; data: AppendCostRequest },
  TContext
> => {
  const mutationOptions =
    getAppendInterviewCostApiV1InterviewsInterviewIdAppendCostPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Get Interview State
 */
export const getInterviewStateApiV1InterviewsStateGet = (
  params: GetInterviewStateApiV1InterviewsStateGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<GetInterviewStateResponse>({
    url: `/api/v1/interviews/state`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetInterviewStateApiV1InterviewsStateGetQueryKey = (
  params: GetInterviewStateApiV1InterviewsStateGetParams
) => {
  return [`/api/v1/interviews/state`, ...(params ? [params] : [])] as const
}

export const getGetInterviewStateApiV1InterviewsStateGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>,
  TError = HTTPValidationError
>(
  params: GetInterviewStateApiV1InterviewsStateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetInterviewStateApiV1InterviewsStateGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>
  > = ({ signal }) => getInterviewStateApiV1InterviewsStateGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetInterviewStateApiV1InterviewsStateGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>
>
export type GetInterviewStateApiV1InterviewsStateGetQueryError =
  HTTPValidationError

/**
 * @summary Get Interview State
 */
export const useGetInterviewStateApiV1InterviewsStateGet = <
  TData = Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>,
  TError = HTTPValidationError
>(
  params: GetInterviewStateApiV1InterviewsStateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInterviewStateApiV1InterviewsStateGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetInterviewStateApiV1InterviewsStateGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Increment Connection Count
 */
export const incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost =
  (interviewId: string) => {
    return platformInstance<HttpResponse>({
      url: `/api/v1/interviews/${interviewId}/increment_connection_count`,
      method: 'POST'
    })
  }

export const getIncrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
        >
      >,
      { interviewId: string }
    > = (props) => {
      const { interviewId } = props ?? {}

      return incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost(
        interviewId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type IncrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
      >
    >
  >

export type IncrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPostMutationError =
  HTTPValidationError

/**
 * @summary Increment Connection Count
 */
export const useIncrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
        >
      >,
      TError,
      { interviewId: string },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof incrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPost
      >
    >,
    TError,
    { interviewId: string },
    TContext
  > => {
    const mutationOptions =
      getIncrementConnectionCountApiV1InterviewsInterviewIdIncrementConnectionCountPostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Mark Service Error
 */
export const markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost = (
  interviewId: string,
  markServiceErrorRequest: MarkServiceErrorRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/interviews/${interviewId}/mark-service-error`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: markServiceErrorRequest
  })
}

export const getMarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
        >
      >,
      TError,
      { interviewId: string; data: MarkServiceErrorRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
      >
    >,
    TError,
    { interviewId: string; data: MarkServiceErrorRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
        >
      >,
      { interviewId: string; data: MarkServiceErrorRequest }
    > = (props) => {
      const { interviewId, data } = props ?? {}

      return markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost(
        interviewId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type MarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
      >
    >
  >
export type MarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPostMutationBody =
  MarkServiceErrorRequest
export type MarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPostMutationError =
  HTTPValidationError

/**
 * @summary Mark Service Error
 */
export const useMarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
        >
      >,
      TError,
      { interviewId: string; data: MarkServiceErrorRequest },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof markServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPost
      >
    >,
    TError,
    { interviewId: string; data: MarkServiceErrorRequest },
    TContext
  > => {
    const mutationOptions =
      getMarkServiceErrorApiV1InterviewsInterviewIdMarkServiceErrorPostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Ensure Interview
 */
export const ensureInterviewApiV2InterviewsEnsurePost = (
  createInterviewRequest: CreateInterviewRequest
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v2/interviews/ensure`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInterviewRequest
  })
}

export const getEnsureInterviewApiV2InterviewsEnsurePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>,
    { data: CreateInterviewRequest }
  > = (props) => {
    const { data } = props ?? {}

    return ensureInterviewApiV2InterviewsEnsurePost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type EnsureInterviewApiV2InterviewsEnsurePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>
  >
export type EnsureInterviewApiV2InterviewsEnsurePostMutationBody =
  CreateInterviewRequest
export type EnsureInterviewApiV2InterviewsEnsurePostMutationError =
  HTTPValidationError

/**
 * @summary Ensure Interview
 */
export const useEnsureInterviewApiV2InterviewsEnsurePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>,
    TError,
    { data: CreateInterviewRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof ensureInterviewApiV2InterviewsEnsurePost>>,
  TError,
  { data: CreateInterviewRequest },
  TContext
> => {
  const mutationOptions =
    getEnsureInterviewApiV2InterviewsEnsurePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Heygen Config
 */
export const getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost = (
  vacancyId: string
) => {
  return platformInstance<GetHeygenConfigResponse>({
    url: `/api/v1/vacancies/${vacancyId}/heygen-config`,
    method: 'POST'
  })
}

export const getGetHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost
        >
      >,
      TError,
      { vacancyId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost>
    >,
    TError,
    { vacancyId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost
        >
      >,
      { vacancyId: string }
    > = (props) => {
      const { vacancyId } = props ?? {}

      return getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost(vacancyId)
    }

    return { mutationFn, ...mutationOptions }
  }

export type GetHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost>
    >
  >

export type GetHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPostMutationError =
  HTTPValidationError

/**
 * @summary Get Heygen Config
 */
export const useGetHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost>
    >,
    TError,
    { vacancyId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof getHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPost>
  >,
  TError,
  { vacancyId: string },
  TContext
> => {
  const mutationOptions =
    getGetHeygenConfigApiV1VacanciesVacancyIdHeygenConfigPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary List Vacancies
 */
export const listVacanciesApiV1VacanciesGet = (
  params?: ListVacanciesApiV1VacanciesGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListVacanciesResponse>({
    url: `/api/v1/vacancies/`,
    method: 'GET',
    params,
    signal
  })
}

export const getListVacanciesApiV1VacanciesGetQueryKey = (
  params?: ListVacanciesApiV1VacanciesGetParams
) => {
  return [`/api/v1/vacancies/`, ...(params ? [params] : [])] as const
}

export const getListVacanciesApiV1VacanciesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListVacanciesApiV1VacanciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getListVacanciesApiV1VacanciesGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>
  > = ({ signal }) => listVacanciesApiV1VacanciesGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListVacanciesApiV1VacanciesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>
>
export type ListVacanciesApiV1VacanciesGetQueryError = HTTPValidationError

/**
 * @summary List Vacancies
 */
export const useListVacanciesApiV1VacanciesGet = <
  TData = Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>,
  TError = HTTPValidationError
>(
  params?: ListVacanciesApiV1VacanciesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVacanciesApiV1VacanciesGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListVacanciesApiV1VacanciesGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Vacancy
 */
export const createVacancyApiV1VacanciesPost = (
  vacancyCreateRequest: VacancyCreateRequest
) => {
  return platformInstance<GetVacancyResponse>({
    url: `/api/v1/vacancies/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: vacancyCreateRequest
  })
}

export const getCreateVacancyApiV1VacanciesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>,
    TError,
    { data: VacancyCreateRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>,
  TError,
  { data: VacancyCreateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>,
    { data: VacancyCreateRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createVacancyApiV1VacanciesPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateVacancyApiV1VacanciesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>
>
export type CreateVacancyApiV1VacanciesPostMutationBody = VacancyCreateRequest
export type CreateVacancyApiV1VacanciesPostMutationError = HTTPValidationError

/**
 * @summary Create Vacancy
 */
export const useCreateVacancyApiV1VacanciesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>,
    TError,
    { data: VacancyCreateRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createVacancyApiV1VacanciesPost>>,
  TError,
  { data: VacancyCreateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateVacancyApiV1VacanciesPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Vacancy By Id
 */
export const getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet = (
  vacancyIdOrAlias: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetVacancyResponse>({
    url: `/api/v1/vacancies/${vacancyIdOrAlias}`,
    method: 'GET',
    signal
  })
}

export const getGetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryKey = (
  vacancyIdOrAlias: string
) => {
  return [`/api/v1/vacancies/${vacancyIdOrAlias}`] as const
}

export const getGetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>
  >,
  TError = HTTPValidationError
>(
  vacancyIdOrAlias: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryKey(vacancyIdOrAlias)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>>
  > = ({ signal }) =>
    getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet(vacancyIdOrAlias, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!vacancyIdOrAlias,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>>
  >
export type GetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryError =
  HTTPValidationError

/**
 * @summary Get Vacancy By Id
 */
export const useGetVacancyByIdApiV1VacanciesVacancyIdOrAliasGet = <
  TData = Awaited<
    ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>
  >,
  TError = HTTPValidationError
>(
  vacancyIdOrAlias: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVacancyByIdApiV1VacanciesVacancyIdOrAliasGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetVacancyByIdApiV1VacanciesVacancyIdOrAliasGetQueryOptions(
      vacancyIdOrAlias,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Vacancy By Id Public
 */
export const getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet = (
  vacancyIdOrAlias: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetVacancyResponse>({
    url: `/api/v1/vacancies/public/${vacancyIdOrAlias}`,
    method: 'GET',
    signal
  })
}

export const getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryKey =
  (vacancyIdOrAlias: string) => {
    return [`/api/v1/vacancies/public/${vacancyIdOrAlias}`] as const
  }

export const getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyIdOrAlias: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryKey(
        vacancyIdOrAlias
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
        >
      >
    > = ({ signal }) =>
      getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet(
        vacancyIdOrAlias,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyIdOrAlias,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
      >
    >
  >
export type GetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryError =
  HTTPValidationError

/**
 * @summary Get Vacancy By Id Public
 */
export const useGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet = <
  TData = Awaited<
    ReturnType<
      typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
    >
  >,
  TError = HTTPValidationError
>(
  vacancyIdOrAlias: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetVacancyByIdPublicApiV1VacanciesPublicVacancyIdOrAliasGetQueryOptions(
      vacancyIdOrAlias,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Vacancy
 */
export const updateVacancyApiV1VacanciesVacancyIdPatch = (
  vacancyId: string,
  vacancyUpdateRequest: VacancyUpdateRequest
) => {
  return platformInstance<GetVacancyResponse>({
    url: `/api/v1/vacancies/${vacancyId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: vacancyUpdateRequest
  })
}

export const getUpdateVacancyApiV1VacanciesVacancyIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>,
    TError,
    { vacancyId: string; data: VacancyUpdateRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>,
  TError,
  { vacancyId: string; data: VacancyUpdateRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>,
    { vacancyId: string; data: VacancyUpdateRequest }
  > = (props) => {
    const { vacancyId, data } = props ?? {}

    return updateVacancyApiV1VacanciesVacancyIdPatch(vacancyId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateVacancyApiV1VacanciesVacancyIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>
  >
export type UpdateVacancyApiV1VacanciesVacancyIdPatchMutationBody =
  VacancyUpdateRequest
export type UpdateVacancyApiV1VacanciesVacancyIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Vacancy
 */
export const useUpdateVacancyApiV1VacanciesVacancyIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>,
    TError,
    { vacancyId: string; data: VacancyUpdateRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVacancyApiV1VacanciesVacancyIdPatch>>,
  TError,
  { vacancyId: string; data: VacancyUpdateRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateVacancyApiV1VacanciesVacancyIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Delete Vacancy
 */
export const deleteVacancyApiV1VacanciesVacancyIdDelete = (
  vacancyId: string
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/vacancies/${vacancyId}`,
    method: 'DELETE'
  })
}

export const getDeleteVacancyApiV1VacanciesVacancyIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>,
    TError,
    { vacancyId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>,
  TError,
  { vacancyId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>,
    { vacancyId: string }
  > = (props) => {
    const { vacancyId } = props ?? {}

    return deleteVacancyApiV1VacanciesVacancyIdDelete(vacancyId)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteVacancyApiV1VacanciesVacancyIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>
  >

export type DeleteVacancyApiV1VacanciesVacancyIdDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Vacancy
 */
export const useDeleteVacancyApiV1VacanciesVacancyIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>,
    TError,
    { vacancyId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVacancyApiV1VacanciesVacancyIdDelete>>,
  TError,
  { vacancyId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteVacancyApiV1VacanciesVacancyIdDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Active Interview
 */
export const getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetInterviewResponse>({
    url: `/api/v1/vacancies/${vacancyId}/active_interview`,
    method: 'GET',
    signal
  })
}

export const getGetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryKey =
  (vacancyId: string) => {
    return [`/api/v1/vacancies/${vacancyId}/active_interview`] as const
  }

export const getGetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryKey(
        vacancyId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
        >
      >
    > = ({ signal }) =>
      getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet(
        vacancyId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
      >
    >
  >
export type GetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryError =
  HTTPValidationError

/**
 * @summary Get Active Interview
 */
export const useGetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet = <
  TData = Awaited<
    ReturnType<
      typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
    >
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetActiveInterviewApiV1VacanciesVacancyIdActiveInterviewGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Vacancy Voices
 */
export const getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<SrcDomainsVacancySchemasGetVoicesResponse>({
    url: `/api/v1/vacancies/${vacancyId}/voices`,
    method: 'GET',
    signal
  })
}

export const getGetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryKey = (
  vacancyId: string
) => {
  return [`/api/v1/vacancies/${vacancyId}/voices`] as const
}

export const getGetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryKey(vacancyId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>>
  > = ({ signal }) =>
    getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet(vacancyId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!vacancyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>
    >,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>>
  >
export type GetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryError =
  HTTPValidationError

/**
 * @summary Get Vacancy Voices
 */
export const useGetVacancyVoicesApiV1VacanciesVacancyIdVoicesGet = <
  TData = Awaited<
    ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getVacancyVoicesApiV1VacanciesVacancyIdVoicesGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetVacancyVoicesApiV1VacanciesVacancyIdVoicesGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Welcome Message
 */
export const getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<StringOrNoneResponse>({
    url: `/api/v1/vacancies/${vacancyId}/welcome_message`,
    method: 'GET',
    signal
  })
}

export const getGetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryKey =
  (vacancyId: string) => {
    return [`/api/v1/vacancies/${vacancyId}/welcome_message`] as const
  }

export const getGetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryKey(
        vacancyId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
        >
      >
    > = ({ signal }) =>
      getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet(
        vacancyId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
      >
    >
  >
export type GetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryError =
  HTTPValidationError

/**
 * @summary Get Welcome Message
 */
export const useGetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet = <
  TData = Awaited<
    ReturnType<typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetWelcomeMessageApiV1VacanciesVacancyIdWelcomeMessageGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Evaluation Template
 */
export const getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet =
  (vacancyId: string, signal?: AbortSignal) => {
    return platformInstance<GetEvaluationTemplateResponse>({
      url: `/api/v1/vacancies/${vacancyId}/evaluation_template`,
      method: 'GET',
      signal
    })
  }

export const getGetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryKey =
  (vacancyId: string) => {
    return [`/api/v1/vacancies/${vacancyId}/evaluation_template`] as const
  }

export const getGetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryKey(
        vacancyId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
        >
      >
    > = ({ signal }) =>
      getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet(
        vacancyId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
      >
    >
  >
export type GetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryError =
  HTTPValidationError

/**
 * @summary Get Evaluation Template
 */
export const useGetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet =
  <
    TData = Awaited<
      ReturnType<
        typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      getGetEvaluationTemplateApiV1VacanciesVacancyIdEvaluationTemplateGetQueryOptions(
        vacancyId,
        options
      )

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey
    }

    query.queryKey = queryOptions.queryKey

    return query
  }

/**
 * @summary Get Vacancy Ui Settings
 */
export const getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetVacancyUISettingsResponse>({
    url: `/api/v1/vacancies/${vacancyId}/ui_settings`,
    method: 'GET',
    signal
  })
}

export const getGetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryKey =
  (vacancyId: string) => {
    return [`/api/v1/vacancies/${vacancyId}/ui_settings`] as const
  }

export const getGetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryKey(
        vacancyId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
        >
      >
    > = ({ signal }) =>
      getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet(
        vacancyId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
      >
    >
  >
export type GetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryError =
  HTTPValidationError

/**
 * @summary Get Vacancy Ui Settings
 */
export const useGetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet = <
  TData = Awaited<
    ReturnType<typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGet
          >
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Vacancy Ui Settings
 */
export const updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost = (
  vacancyId: string,
  updateVacancyUISettingsRequest: UpdateVacancyUISettingsRequest
) => {
  return platformInstance<UpdateVacancyUISettingsResponse>({
    url: `/api/v1/vacancies/${vacancyId}/ui_settings`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateVacancyUISettingsRequest
  })
}

export const getUpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
        >
      >,
      TError,
      { vacancyId: string; data: UpdateVacancyUISettingsRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
      >
    >,
    TError,
    { vacancyId: string; data: UpdateVacancyUISettingsRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
        >
      >,
      { vacancyId: string; data: UpdateVacancyUISettingsRequest }
    > = (props) => {
      const { vacancyId, data } = props ?? {}

      return updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost(
        vacancyId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
      >
    >
  >
export type UpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPostMutationBody =
  UpdateVacancyUISettingsRequest
export type UpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPostMutationError =
  HTTPValidationError

/**
 * @summary Update Vacancy Ui Settings
 */
export const useUpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
      >
    >,
    TError,
    { vacancyId: string; data: UpdateVacancyUISettingsRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPost
    >
  >,
  TError,
  { vacancyId: string; data: UpdateVacancyUISettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateVacancyUiSettingsApiV1VacanciesVacancyIdUiSettingsPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Import Vacancy From Text
 */
export const importVacancyFromTextApiV1VacanciesImportTextPost = (
  importVacancyFromTextRequest: ImportVacancyFromTextRequest
) => {
  return platformInstance<ImportVacancyFromTextResponse>({
    url: `/api/v1/vacancies/import/text`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: importVacancyFromTextRequest
  })
}

export const getImportVacancyFromTextApiV1VacanciesImportTextPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>
      >,
      TError,
      { data: ImportVacancyFromTextRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>
    >,
    TError,
    { data: ImportVacancyFromTextRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>
      >,
      { data: ImportVacancyFromTextRequest }
    > = (props) => {
      const { data } = props ?? {}

      return importVacancyFromTextApiV1VacanciesImportTextPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type ImportVacancyFromTextApiV1VacanciesImportTextPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>
    >
  >
export type ImportVacancyFromTextApiV1VacanciesImportTextPostMutationBody =
  ImportVacancyFromTextRequest
export type ImportVacancyFromTextApiV1VacanciesImportTextPostMutationError =
  HTTPValidationError

/**
 * @summary Import Vacancy From Text
 */
export const useImportVacancyFromTextApiV1VacanciesImportTextPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>
    >,
    TError,
    { data: ImportVacancyFromTextRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof importVacancyFromTextApiV1VacanciesImportTextPost>>,
  TError,
  { data: ImportVacancyFromTextRequest },
  TContext
> => {
  const mutationOptions =
    getImportVacancyFromTextApiV1VacanciesImportTextPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Company
 */
export const getCompanyApiV1CompaniesCompanyIdGet = (
  companyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetCompanyResponse>({
    url: `/api/v1/companies/${companyId}`,
    method: 'GET',
    signal
  })
}

export const getGetCompanyApiV1CompaniesCompanyIdGetQueryKey = (
  companyId: string
) => {
  return [`/api/v1/companies/${companyId}`] as const
}

export const getGetCompanyApiV1CompaniesCompanyIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>,
  TError = HTTPValidationError
>(
  companyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetCompanyApiV1CompaniesCompanyIdGetQueryKey(companyId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>
  > = ({ signal }) => getCompanyApiV1CompaniesCompanyIdGet(companyId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!companyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetCompanyApiV1CompaniesCompanyIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>
>
export type GetCompanyApiV1CompaniesCompanyIdGetQueryError = HTTPValidationError

/**
 * @summary Get Company
 */
export const useGetCompanyApiV1CompaniesCompanyIdGet = <
  TData = Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>,
  TError = HTTPValidationError
>(
  companyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCompanyApiV1CompaniesCompanyIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompanyApiV1CompaniesCompanyIdGetQueryOptions(
    companyId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Update Company
 */
export const updateCompanyApiV1CompaniesCompanyIdPatch = (
  companyId: string,
  updateCompanyRequest: UpdateCompanyRequest
) => {
  return platformInstance<GetCompanyResponse>({
    url: `/api/v1/companies/${companyId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateCompanyRequest
  })
}

export const getUpdateCompanyApiV1CompaniesCompanyIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>,
    TError,
    { companyId: string; data: UpdateCompanyRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>,
  TError,
  { companyId: string; data: UpdateCompanyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>,
    { companyId: string; data: UpdateCompanyRequest }
  > = (props) => {
    const { companyId, data } = props ?? {}

    return updateCompanyApiV1CompaniesCompanyIdPatch(companyId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateCompanyApiV1CompaniesCompanyIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>
  >
export type UpdateCompanyApiV1CompaniesCompanyIdPatchMutationBody =
  UpdateCompanyRequest
export type UpdateCompanyApiV1CompaniesCompanyIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Company
 */
export const useUpdateCompanyApiV1CompaniesCompanyIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>,
    TError,
    { companyId: string; data: UpdateCompanyRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCompanyApiV1CompaniesCompanyIdPatch>>,
  TError,
  { companyId: string; data: UpdateCompanyRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateCompanyApiV1CompaniesCompanyIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Companies
 */
export const listCompaniesApiV1CompaniesGet = (
  params?: ListCompaniesApiV1CompaniesGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListCompaniesResponse>({
    url: `/api/v1/companies/`,
    method: 'GET',
    params,
    signal
  })
}

export const getListCompaniesApiV1CompaniesGetQueryKey = (
  params?: ListCompaniesApiV1CompaniesGetParams
) => {
  return [`/api/v1/companies/`, ...(params ? [params] : [])] as const
}

export const getListCompaniesApiV1CompaniesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>,
  TError = HTTPValidationError
>(
  params?: ListCompaniesApiV1CompaniesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getListCompaniesApiV1CompaniesGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>
  > = ({ signal }) => listCompaniesApiV1CompaniesGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListCompaniesApiV1CompaniesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>
>
export type ListCompaniesApiV1CompaniesGetQueryError = HTTPValidationError

/**
 * @summary List Companies
 */
export const useListCompaniesApiV1CompaniesGet = <
  TData = Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>,
  TError = HTTPValidationError
>(
  params?: ListCompaniesApiV1CompaniesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCompaniesApiV1CompaniesGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getListCompaniesApiV1CompaniesGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Company
 */
export const createCompanyApiV1CompaniesPost = (
  createCompanyRequest: CreateCompanyRequest
) => {
  return platformInstance<GetCompanyResponse>({
    url: `/api/v1/companies/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCompanyRequest
  })
}

export const getCreateCompanyApiV1CompaniesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>,
    TError,
    { data: CreateCompanyRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>,
  TError,
  { data: CreateCompanyRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>,
    { data: CreateCompanyRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createCompanyApiV1CompaniesPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateCompanyApiV1CompaniesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>
>
export type CreateCompanyApiV1CompaniesPostMutationBody = CreateCompanyRequest
export type CreateCompanyApiV1CompaniesPostMutationError = HTTPValidationError

/**
 * @summary Create Company
 */
export const useCreateCompanyApiV1CompaniesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>,
    TError,
    { data: CreateCompanyRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createCompanyApiV1CompaniesPost>>,
  TError,
  { data: CreateCompanyRequest },
  TContext
> => {
  const mutationOptions =
    getCreateCompanyApiV1CompaniesPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Add Users To Company
 */
export const addUsersToCompanyApiV1CompaniesCompanyIdUsersPost = (
  companyId: string,
  addUsersToCompanyRequest: AddUsersToCompanyRequest
) => {
  return platformInstance<HttpResponse>({
    url: `/api/v1/companies/${companyId}/users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addUsersToCompanyRequest
  })
}

export const getAddUsersToCompanyApiV1CompaniesCompanyIdUsersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>
      >,
      TError,
      { companyId: string; data: AddUsersToCompanyRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>
    >,
    TError,
    { companyId: string; data: AddUsersToCompanyRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>
      >,
      { companyId: string; data: AddUsersToCompanyRequest }
    > = (props) => {
      const { companyId, data } = props ?? {}

      return addUsersToCompanyApiV1CompaniesCompanyIdUsersPost(companyId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type AddUsersToCompanyApiV1CompaniesCompanyIdUsersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>
    >
  >
export type AddUsersToCompanyApiV1CompaniesCompanyIdUsersPostMutationBody =
  AddUsersToCompanyRequest
export type AddUsersToCompanyApiV1CompaniesCompanyIdUsersPostMutationError =
  HTTPValidationError

/**
 * @summary Add Users To Company
 */
export const useAddUsersToCompanyApiV1CompaniesCompanyIdUsersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>
    >,
    TError,
    { companyId: string; data: AddUsersToCompanyRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof addUsersToCompanyApiV1CompaniesCompanyIdUsersPost>>,
  TError,
  { companyId: string; data: AddUsersToCompanyRequest },
  TContext
> => {
  const mutationOptions =
    getAddUsersToCompanyApiV1CompaniesCompanyIdUsersPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Company V2
 */
export const getCompanyV2ApiV2CompaniesCompanyIdGet = (
  companyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetCompanyResponseV2>({
    url: `/api/v2/companies/${companyId}`,
    method: 'GET',
    signal
  })
}

export const getGetCompanyV2ApiV2CompaniesCompanyIdGetQueryKey = (
  companyId: string
) => {
  return [`/api/v2/companies/${companyId}`] as const
}

export const getGetCompanyV2ApiV2CompaniesCompanyIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>,
  TError = HTTPValidationError
>(
  companyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetCompanyV2ApiV2CompaniesCompanyIdGetQueryKey(companyId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>
  > = ({ signal }) => getCompanyV2ApiV2CompaniesCompanyIdGet(companyId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!companyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetCompanyV2ApiV2CompaniesCompanyIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>
>
export type GetCompanyV2ApiV2CompaniesCompanyIdGetQueryError =
  HTTPValidationError

/**
 * @summary Get Company V2
 */
export const useGetCompanyV2ApiV2CompaniesCompanyIdGet = <
  TData = Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>,
  TError = HTTPValidationError
>(
  companyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCompanyV2ApiV2CompaniesCompanyIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCompanyV2ApiV2CompaniesCompanyIdGetQueryOptions(
    companyId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get Notification Email By Id
 */
export const getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet =
  (notificationEmailId: string, signal?: AbortSignal) => {
    return platformInstance<GetNotificationEmailResponse>({
      url: `/api/v1/notifications/emails/${notificationEmailId}`,
      method: 'GET',
      signal
    })
  }

export const getGetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryKey =
  (notificationEmailId: string) => {
    return [`/api/v1/notifications/emails/${notificationEmailId}`] as const
  }

export const getGetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    notificationEmailId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryKey(
        notificationEmailId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
        >
      >
    > = ({ signal }) =>
      getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet(
        notificationEmailId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!notificationEmailId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
      >
    >
  >
export type GetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryError =
  HTTPValidationError

/**
 * @summary Get Notification Email By Id
 */
export const useGetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet =
  <
    TData = Awaited<
      ReturnType<
        typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    notificationEmailId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      getGetNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdGetQueryOptions(
        notificationEmailId,
        options
      )

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey
    }

    query.queryKey = queryOptions.queryKey

    return query
  }

/**
 * @summary Update Notification Email
 */
export const updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch =
  (
    notificationEmailId: string,
    updateNotificationEmailRequest: UpdateNotificationEmailRequest
  ) => {
    return platformInstance<GetNotificationEmailResponse>({
      url: `/api/v1/notifications/emails/${notificationEmailId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateNotificationEmailRequest
    })
  }

export const getUpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
        >
      >,
      TError,
      { notificationEmailId: string; data: UpdateNotificationEmailRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
      >
    >,
    TError,
    { notificationEmailId: string; data: UpdateNotificationEmailRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
        >
      >,
      { notificationEmailId: string; data: UpdateNotificationEmailRequest }
    > = (props) => {
      const { notificationEmailId, data } = props ?? {}

      return updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch(
        notificationEmailId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
      >
    >
  >
export type UpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatchMutationBody =
  UpdateNotificationEmailRequest
export type UpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Notification Email
 */
export const useUpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
        >
      >,
      TError,
      { notificationEmailId: string; data: UpdateNotificationEmailRequest },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatch
      >
    >,
    TError,
    { notificationEmailId: string; data: UpdateNotificationEmailRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateNotificationEmailApiV1NotificationsEmailsNotificationEmailIdPatchMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Delete Notification Email By Id
 */
export const deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete =
  (notificationEmailId: string) => {
    return platformInstance<HttpResponse>({
      url: `/api/v1/notifications/emails/${notificationEmailId}`,
      method: 'DELETE'
    })
  }

export const getDeleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
        >
      >,
      TError,
      { notificationEmailId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
      >
    >,
    TError,
    { notificationEmailId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
        >
      >,
      { notificationEmailId: string }
    > = (props) => {
      const { notificationEmailId } = props ?? {}

      return deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete(
        notificationEmailId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type DeleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
      >
    >
  >

export type DeleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete Notification Email By Id
 */
export const useDeleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
        >
      >,
      TError,
      { notificationEmailId: string },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDelete
      >
    >,
    TError,
    { notificationEmailId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteNotificationEmailByIdApiV1NotificationsEmailsNotificationEmailIdDeleteMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary List Notification Emails
 */
export const listNotificationEmailsApiV1NotificationsEmailsGet = (
  params?: ListNotificationEmailsApiV1NotificationsEmailsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListNotificationEmailsResponse>({
    url: `/api/v1/notifications/emails`,
    method: 'GET',
    params,
    signal
  })
}

export const getListNotificationEmailsApiV1NotificationsEmailsGetQueryKey = (
  params?: ListNotificationEmailsApiV1NotificationsEmailsGetParams
) => {
  return [`/api/v1/notifications/emails`, ...(params ? [params] : [])] as const
}

export const getListNotificationEmailsApiV1NotificationsEmailsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListNotificationEmailsApiV1NotificationsEmailsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getListNotificationEmailsApiV1NotificationsEmailsGetQueryKey(params)

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
      >
    > = ({ signal }) =>
      listNotificationEmailsApiV1NotificationsEmailsGet(params, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type ListNotificationEmailsApiV1NotificationsEmailsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
    >
  >
export type ListNotificationEmailsApiV1NotificationsEmailsGetQueryError =
  HTTPValidationError

/**
 * @summary List Notification Emails
 */
export const useListNotificationEmailsApiV1NotificationsEmailsGet = <
  TData = Awaited<
    ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListNotificationEmailsApiV1NotificationsEmailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listNotificationEmailsApiV1NotificationsEmailsGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListNotificationEmailsApiV1NotificationsEmailsGetQueryOptions(
      params,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Notification Email
 */
export const createNotificationEmailApiV1NotificationsEmailsPost = (
  createNotificationEmailRequest: CreateNotificationEmailRequest
) => {
  return platformInstance<GetNotificationEmailResponse>({
    url: `/api/v1/notifications/emails`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createNotificationEmailRequest
  })
}

export const getCreateNotificationEmailApiV1NotificationsEmailsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
      >,
      TError,
      { data: CreateNotificationEmailRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
    >,
    TError,
    { data: CreateNotificationEmailRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
      >,
      { data: CreateNotificationEmailRequest }
    > = (props) => {
      const { data } = props ?? {}

      return createNotificationEmailApiV1NotificationsEmailsPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type CreateNotificationEmailApiV1NotificationsEmailsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
    >
  >
export type CreateNotificationEmailApiV1NotificationsEmailsPostMutationBody =
  CreateNotificationEmailRequest
export type CreateNotificationEmailApiV1NotificationsEmailsPostMutationError =
  HTTPValidationError

/**
 * @summary Create Notification Email
 */
export const useCreateNotificationEmailApiV1NotificationsEmailsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
    >,
    TError,
    { data: CreateNotificationEmailRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof createNotificationEmailApiV1NotificationsEmailsPost>
  >,
  TError,
  { data: CreateNotificationEmailRequest },
  TContext
> => {
  const mutationOptions =
    getCreateNotificationEmailApiV1NotificationsEmailsPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Store Notification Emails
 */
export const storeNotificationEmailsApiV1NotificationsEmailsStorePost = (
  storeNotificationEmailsRequest: StoreNotificationEmailsRequest
) => {
  return platformInstance<ListNotificationEmailsResponse>({
    url: `/api/v1/notifications/emails/store`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: storeNotificationEmailsRequest
  })
}

export const getStoreNotificationEmailsApiV1NotificationsEmailsStorePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost
        >
      >,
      TError,
      { data: StoreNotificationEmailsRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost
      >
    >,
    TError,
    { data: StoreNotificationEmailsRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost
        >
      >,
      { data: StoreNotificationEmailsRequest }
    > = (props) => {
      const { data } = props ?? {}

      return storeNotificationEmailsApiV1NotificationsEmailsStorePost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type StoreNotificationEmailsApiV1NotificationsEmailsStorePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost
      >
    >
  >
export type StoreNotificationEmailsApiV1NotificationsEmailsStorePostMutationBody =
  StoreNotificationEmailsRequest
export type StoreNotificationEmailsApiV1NotificationsEmailsStorePostMutationError =
  HTTPValidationError

/**
 * @summary Store Notification Emails
 */
export const useStoreNotificationEmailsApiV1NotificationsEmailsStorePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost
      >
    >,
    TError,
    { data: StoreNotificationEmailsRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof storeNotificationEmailsApiV1NotificationsEmailsStorePost>
  >,
  TError,
  { data: StoreNotificationEmailsRequest },
  TContext
> => {
  const mutationOptions =
    getStoreNotificationEmailsApiV1NotificationsEmailsStorePostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Create Evaluation Template
 */
export const createEvaluationTemplateApiV1EvaluationTemplatesPost = (
  createEvaluationTemplateRequest: CreateEvaluationTemplateRequest
) => {
  return platformInstance<GetEvaluationTemplateResponse>({
    url: `/api/v1/evaluation/templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEvaluationTemplateRequest
  })
}

export const getCreateEvaluationTemplateApiV1EvaluationTemplatesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
      >,
      TError,
      { data: CreateEvaluationTemplateRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
    >,
    TError,
    { data: CreateEvaluationTemplateRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
      >,
      { data: CreateEvaluationTemplateRequest }
    > = (props) => {
      const { data } = props ?? {}

      return createEvaluationTemplateApiV1EvaluationTemplatesPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type CreateEvaluationTemplateApiV1EvaluationTemplatesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
    >
  >
export type CreateEvaluationTemplateApiV1EvaluationTemplatesPostMutationBody =
  CreateEvaluationTemplateRequest
export type CreateEvaluationTemplateApiV1EvaluationTemplatesPostMutationError =
  HTTPValidationError

/**
 * @summary Create Evaluation Template
 */
export const useCreateEvaluationTemplateApiV1EvaluationTemplatesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
    >,
    TError,
    { data: CreateEvaluationTemplateRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof createEvaluationTemplateApiV1EvaluationTemplatesPost>
  >,
  TError,
  { data: CreateEvaluationTemplateRequest },
  TContext
> => {
  const mutationOptions =
    getCreateEvaluationTemplateApiV1EvaluationTemplatesPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Update Evaluation Template
 */
export const updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch =
  (
    evaluationTemplateId: string,
    updateEvaluationTemplateRequest: UpdateEvaluationTemplateRequest
  ) => {
    return platformInstance<GetEvaluationTemplateResponse>({
      url: `/api/v1/evaluation/templates/${evaluationTemplateId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEvaluationTemplateRequest
    })
  }

export const getUpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
        >
      >,
      TError,
      { evaluationTemplateId: string; data: UpdateEvaluationTemplateRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
      >
    >,
    TError,
    { evaluationTemplateId: string; data: UpdateEvaluationTemplateRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
        >
      >,
      { evaluationTemplateId: string; data: UpdateEvaluationTemplateRequest }
    > = (props) => {
      const { evaluationTemplateId, data } = props ?? {}

      return updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch(
        evaluationTemplateId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
      >
    >
  >
export type UpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatchMutationBody =
  UpdateEvaluationTemplateRequest
export type UpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Evaluation Template
 */
export const useUpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
        >
      >,
      TError,
      { evaluationTemplateId: string; data: UpdateEvaluationTemplateRequest },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatch
      >
    >,
    TError,
    { evaluationTemplateId: string; data: UpdateEvaluationTemplateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateEvaluationTemplateApiV1EvaluationTemplatesEvaluationTemplateIdPatchMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary List Criterias
 */
export const listCriteriasApiV1VacanciesVacancyIdCriteriasGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<ListVacancyCriteriaResponse>({
    url: `/api/v1/vacancies/${vacancyId}/criterias`,
    method: 'GET',
    signal
  })
}

export const getListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryKey = (
  vacancyId: string
) => {
  return [`/api/v1/vacancies/${vacancyId}/criterias`] as const
}

export const getListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryKey(vacancyId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>>
  > = ({ signal }) =>
    listCriteriasApiV1VacanciesVacancyIdCriteriasGet(vacancyId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!vacancyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>
    >,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>>
  >
export type ListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryError =
  HTTPValidationError

/**
 * @summary List Criterias
 */
export const useListCriteriasApiV1VacanciesVacancyIdCriteriasGet = <
  TData = Awaited<
    ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listCriteriasApiV1VacanciesVacancyIdCriteriasGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListCriteriasApiV1VacanciesVacancyIdCriteriasGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Store Criterias
 */
export const storeCriteriasApiV1VacanciesVacancyIdCriteriasPost = (
  vacancyId: string,
  vacancyCriteriaStoreRequest: VacancyCriteriaStoreRequest
) => {
  return platformInstance<UpdateVacancyCriteriaResponse>({
    url: `/api/v1/vacancies/${vacancyId}/criterias`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: vacancyCriteriaStoreRequest
  })
}

export const getStoreCriteriasApiV1VacanciesVacancyIdCriteriasPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
      >,
      TError,
      { vacancyId: string; data: VacancyCriteriaStoreRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
    >,
    TError,
    { vacancyId: string; data: VacancyCriteriaStoreRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
      >,
      { vacancyId: string; data: VacancyCriteriaStoreRequest }
    > = (props) => {
      const { vacancyId, data } = props ?? {}

      return storeCriteriasApiV1VacanciesVacancyIdCriteriasPost(vacancyId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type StoreCriteriasApiV1VacanciesVacancyIdCriteriasPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
    >
  >
export type StoreCriteriasApiV1VacanciesVacancyIdCriteriasPostMutationBody =
  VacancyCriteriaStoreRequest
export type StoreCriteriasApiV1VacanciesVacancyIdCriteriasPostMutationError =
  HTTPValidationError

/**
 * @summary Store Criterias
 */
export const useStoreCriteriasApiV1VacanciesVacancyIdCriteriasPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
    >,
    TError,
    { vacancyId: string; data: VacancyCriteriaStoreRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof storeCriteriasApiV1VacanciesVacancyIdCriteriasPost>
  >,
  TError,
  { vacancyId: string; data: VacancyCriteriaStoreRequest },
  TContext
> => {
  const mutationOptions =
    getStoreCriteriasApiV1VacanciesVacancyIdCriteriasPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Liveness
 */
export const livenessV1StatusReadinessGet = (signal?: AbortSignal) => {
  return platformInstance<LivenessV1StatusReadinessGet200>({
    url: `/v1/status/readiness`,
    method: 'GET',
    signal
  })
}

export const getLivenessV1StatusReadinessGetQueryKey = () => {
  return [`/v1/status/readiness`] as const
}

export const getLivenessV1StatusReadinessGetQueryOptions = <
  TData = Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getLivenessV1StatusReadinessGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>
  > = ({ signal }) => livenessV1StatusReadinessGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type LivenessV1StatusReadinessGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>
>
export type LivenessV1StatusReadinessGetQueryError = HTTPValidationError

/**
 * @summary Liveness
 */
export const useLivenessV1StatusReadinessGet = <
  TData = Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof livenessV1StatusReadinessGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLivenessV1StatusReadinessGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Liveness
 */
export const livenessV1StatusLivenessGet = (signal?: AbortSignal) => {
  return platformInstance<LivenessV1StatusLivenessGet200>({
    url: `/v1/status/liveness`,
    method: 'GET',
    signal
  })
}

export const getLivenessV1StatusLivenessGetQueryKey = () => {
  return [`/v1/status/liveness`] as const
}

export const getLivenessV1StatusLivenessGetQueryOptions = <
  TData = Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getLivenessV1StatusLivenessGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>
  > = ({ signal }) => livenessV1StatusLivenessGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type LivenessV1StatusLivenessGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>
>
export type LivenessV1StatusLivenessGetQueryError = HTTPValidationError

/**
 * @summary Liveness
 */
export const useLivenessV1StatusLivenessGet = <
  TData = Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof livenessV1StatusLivenessGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getLivenessV1StatusLivenessGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Token
 */
export const createTokenApiV1HeygenCreateTokenPost = () => {
  return platformInstance<GetHeygenCreateTokenResponse>({
    url: `/api/v1/heygen/create-token`,
    method: 'POST'
  })
}

export const getCreateTokenApiV1HeygenCreateTokenPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>,
    void
  > = () => {
    return createTokenApiV1HeygenCreateTokenPost()
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateTokenApiV1HeygenCreateTokenPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>
>

export type CreateTokenApiV1HeygenCreateTokenPostMutationError =
  HTTPValidationError

/**
 * @summary Create Token
 */
export const useCreateTokenApiV1HeygenCreateTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>,
    TError,
    void,
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createTokenApiV1HeygenCreateTokenPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getCreateTokenApiV1HeygenCreateTokenPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary List Red Flags
 */
export const listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<ListVacancyRedFlagResponse>({
    url: `/api/v1/vacancies/${vacancyId}/red-flags`,
    method: 'GET',
    signal
  })
}

export const getListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryKey = (
  vacancyId: string
) => {
  return [`/api/v1/vacancies/${vacancyId}/red-flags`] as const
}

export const getListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryKey(vacancyId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>>
  > = ({ signal }) =>
    listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet(vacancyId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!vacancyId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type ListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>>
  >
export type ListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryError =
  HTTPValidationError

/**
 * @summary List Red Flags
 */
export const useListRedFlagsApiV1VacanciesVacancyIdRedFlagsGet = <
  TData = Awaited<
    ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>
  >,
  TError = HTTPValidationError
>(
  vacancyId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRedFlagsApiV1VacanciesVacancyIdRedFlagsGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getListRedFlagsApiV1VacanciesVacancyIdRedFlagsGetQueryOptions(
      vacancyId,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Store Red Flags
 */
export const storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost = (
  vacancyId: string,
  vacancyRedFlagStoreRequest: VacancyRedFlagStoreRequest
) => {
  return platformInstance<StoreVacancyRedFlagResponse>({
    url: `/api/v1/vacancies/${vacancyId}/red-flags`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: vacancyRedFlagStoreRequest
  })
}

export const getStoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>
      >,
      TError,
      { vacancyId: string; data: VacancyRedFlagStoreRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>
    >,
    TError,
    { vacancyId: string; data: VacancyRedFlagStoreRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>
      >,
      { vacancyId: string; data: VacancyRedFlagStoreRequest }
    > = (props) => {
      const { vacancyId, data } = props ?? {}

      return storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost(vacancyId, data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type StoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>>
  >
export type StoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPostMutationBody =
  VacancyRedFlagStoreRequest
export type StoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPostMutationError =
  HTTPValidationError

/**
 * @summary Store Red Flags
 */
export const useStoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>
    >,
    TError,
    { vacancyId: string; data: VacancyRedFlagStoreRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof storeRedFlagsApiV1VacanciesVacancyIdRedFlagsPost>>,
  TError,
  { vacancyId: string; data: VacancyRedFlagStoreRequest },
  TContext
> => {
  const mutationOptions =
    getStoreRedFlagsApiV1VacanciesVacancyIdRedFlagsPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Inference Settings
 */
export const getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet = (
  vacancyId: string,
  signal?: AbortSignal
) => {
  return platformInstance<GetVacancyInferenceSettingsResponse>({
    url: `/api/v1/vacancy/${vacancyId}/inference-settings`,
    method: 'GET',
    signal
  })
}

export const getGetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryKey =
  (vacancyId: string) => {
    return [`/api/v1/vacancy/${vacancyId}/inference-settings`] as const
  }

export const getGetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getGetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryKey(
        vacancyId
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
        >
      >
    > = ({ signal }) =>
      getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet(
        vacancyId,
        signal
      )

    return {
      queryKey,
      queryFn,
      enabled: !!vacancyId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type GetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
      >
    >
  >
export type GetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryError =
  HTTPValidationError

/**
 * @summary Get Inference Settings
 */
export const useGetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet =
  <
    TData = Awaited<
      ReturnType<
        typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
      >
    >,
    TError = HTTPValidationError
  >(
    vacancyId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      getGetInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsGetQueryOptions(
        vacancyId,
        options
      )

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey
    }

    query.queryKey = queryOptions.queryKey

    return query
  }

/**
 * @summary Update Inference Settings
 */
export const updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch =
  (
    vacancyId: string,
    vacancyInferenceSettingsUpdateRequest: VacancyInferenceSettingsUpdateRequest
  ) => {
    return platformInstance<GetVacancyInferenceSettingsResponse>({
      url: `/api/v1/vacancy/${vacancyId}/inference-settings`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: vacancyInferenceSettingsUpdateRequest
    })
  }

export const getUpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
        >
      >,
      TError,
      { vacancyId: string; data: VacancyInferenceSettingsUpdateRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
      >
    >,
    TError,
    { vacancyId: string; data: VacancyInferenceSettingsUpdateRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
        >
      >,
      { vacancyId: string; data: VacancyInferenceSettingsUpdateRequest }
    > = (props) => {
      const { vacancyId, data } = props ?? {}

      return updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch(
        vacancyId,
        data
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type UpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
      >
    >
  >
export type UpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatchMutationBody =
  VacancyInferenceSettingsUpdateRequest
export type UpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Inference Settings
 */
export const useUpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
        >
      >,
      TError,
      { vacancyId: string; data: VacancyInferenceSettingsUpdateRequest },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatch
      >
    >,
    TError,
    { vacancyId: string; data: VacancyInferenceSettingsUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateInferenceSettingsApiV1VacancyVacancyIdInferenceSettingsPatchMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * @summary Get By Id
 */
export const getByIdApiV1EmployersEmployerIdGet = (
  employerId: string,
  signal?: AbortSignal
) => {
  return platformInstance<EmployerResponse>({
    url: `/api/v1/employers/${employerId}`,
    method: 'GET',
    signal
  })
}

export const getGetByIdApiV1EmployersEmployerIdGetQueryKey = (
  employerId: string
) => {
  return [`/api/v1/employers/${employerId}`] as const
}

export const getGetByIdApiV1EmployersEmployerIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>,
  TError = HTTPValidationError
>(
  employerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetByIdApiV1EmployersEmployerIdGetQueryKey(employerId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>
  > = ({ signal }) => getByIdApiV1EmployersEmployerIdGet(employerId, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!employerId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetByIdApiV1EmployersEmployerIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>
>
export type GetByIdApiV1EmployersEmployerIdGetQueryError = HTTPValidationError

/**
 * @summary Get By Id
 */
export const useGetByIdApiV1EmployersEmployerIdGet = <
  TData = Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>,
  TError = HTTPValidationError
>(
  employerId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getByIdApiV1EmployersEmployerIdGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetByIdApiV1EmployersEmployerIdGetQueryOptions(
    employerId,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Delete
 */
export const deleteApiV1EmployersEmployerIdDelete = (employerId: string) => {
  return platformInstance<void>({
    url: `/api/v1/employers/${employerId}`,
    method: 'DELETE'
  })
}

export const getDeleteApiV1EmployersEmployerIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>,
    TError,
    { employerId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>,
  TError,
  { employerId: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>,
    { employerId: string }
  > = (props) => {
    const { employerId } = props ?? {}

    return deleteApiV1EmployersEmployerIdDelete(employerId)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteApiV1EmployersEmployerIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>
>

export type DeleteApiV1EmployersEmployerIdDeleteMutationError =
  HTTPValidationError

/**
 * @summary Delete
 */
export const useDeleteApiV1EmployersEmployerIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>,
    TError,
    { employerId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiV1EmployersEmployerIdDelete>>,
  TError,
  { employerId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteApiV1EmployersEmployerIdDeleteMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get List
 */
export const getListApiV1EmployersGet = (
  params?: GetListApiV1EmployersGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListEmployersResponse>({
    url: `/api/v1/employers/`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetListApiV1EmployersGetQueryKey = (
  params?: GetListApiV1EmployersGetParams
) => {
  return [`/api/v1/employers/`, ...(params ? [params] : [])] as const
}

export const getGetListApiV1EmployersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getListApiV1EmployersGet>>,
  TError = HTTPValidationError
>(
  params?: GetListApiV1EmployersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getListApiV1EmployersGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetListApiV1EmployersGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getListApiV1EmployersGet>>
  > = ({ signal }) => getListApiV1EmployersGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getListApiV1EmployersGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetListApiV1EmployersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getListApiV1EmployersGet>>
>
export type GetListApiV1EmployersGetQueryError = HTTPValidationError

/**
 * @summary Get List
 */
export const useGetListApiV1EmployersGet = <
  TData = Awaited<ReturnType<typeof getListApiV1EmployersGet>>,
  TError = HTTPValidationError
>(
  params?: GetListApiV1EmployersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getListApiV1EmployersGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetListApiV1EmployersGetQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create
 */
export const createApiV1EmployersPost = (
  createEmployerRequest: CreateEmployerRequest
) => {
  return platformInstance<EmployerResponse>({
    url: `/api/v1/employers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEmployerRequest
  })
}

export const getCreateApiV1EmployersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiV1EmployersPost>>,
    TError,
    { data: CreateEmployerRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApiV1EmployersPost>>,
  TError,
  { data: CreateEmployerRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApiV1EmployersPost>>,
    { data: CreateEmployerRequest }
  > = (props) => {
    const { data } = props ?? {}

    return createApiV1EmployersPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateApiV1EmployersPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApiV1EmployersPost>>
>
export type CreateApiV1EmployersPostMutationBody = CreateEmployerRequest
export type CreateApiV1EmployersPostMutationError = HTTPValidationError

/**
 * @summary Create
 */
export const useCreateApiV1EmployersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiV1EmployersPost>>,
    TError,
    { data: CreateEmployerRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createApiV1EmployersPost>>,
  TError,
  { data: CreateEmployerRequest },
  TContext
> => {
  const mutationOptions = getCreateApiV1EmployersPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Create Transaction
 */
export const createTransactionApiV1PaymentsInterviewTransactionsPost = (
  createInterviewTransactionRequest: CreateInterviewTransactionRequest
) => {
  return platformInstance<GetInterviewTransactionResponse>({
    url: `/api/v1/payments/interview-transactions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInterviewTransactionRequest
  })
}

export const getCreateTransactionApiV1PaymentsInterviewTransactionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createTransactionApiV1PaymentsInterviewTransactionsPost
        >
      >,
      TError,
      { data: CreateInterviewTransactionRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createTransactionApiV1PaymentsInterviewTransactionsPost>
    >,
    TError,
    { data: CreateInterviewTransactionRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createTransactionApiV1PaymentsInterviewTransactionsPost
        >
      >,
      { data: CreateInterviewTransactionRequest }
    > = (props) => {
      const { data } = props ?? {}

      return createTransactionApiV1PaymentsInterviewTransactionsPost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type CreateTransactionApiV1PaymentsInterviewTransactionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createTransactionApiV1PaymentsInterviewTransactionsPost>
    >
  >
export type CreateTransactionApiV1PaymentsInterviewTransactionsPostMutationBody =
  CreateInterviewTransactionRequest
export type CreateTransactionApiV1PaymentsInterviewTransactionsPostMutationError =
  HTTPValidationError

/**
 * @summary Create Transaction
 */
export const useCreateTransactionApiV1PaymentsInterviewTransactionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof createTransactionApiV1PaymentsInterviewTransactionsPost>
    >,
    TError,
    { data: CreateInterviewTransactionRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof createTransactionApiV1PaymentsInterviewTransactionsPost>
  >,
  TError,
  { data: CreateInterviewTransactionRequest },
  TContext
> => {
  const mutationOptions =
    getCreateTransactionApiV1PaymentsInterviewTransactionsPostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary List Interview Transactions
 */
export const listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet = (
  params?: ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<ListInterviewTransactionsResponse>({
    url: `/api/v1/payments/interview-transactions`,
    method: 'GET',
    params,
    signal
  })
}

export const getListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryKey =
  (
    params?: ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams
  ) => {
    return [
      `/api/v1/payments/interview-transactions`,
      ...(params ? [params] : [])
    ] as const
  }

export const getListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ) => {
    const { query: queryOptions } = options ?? {}

    const queryKey =
      queryOptions?.queryKey ??
      getListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryKey(
        params
      )

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
        >
      >
    > = ({ signal }) =>
      listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet(
        params,
        signal
      )

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey }
  }

export type ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
      >
    >
  >
export type ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryError =
  HTTPValidationError

/**
 * @summary List Interview Transactions
 */
export const useListInterviewTransactionsApiV1PaymentsInterviewTransactionsGet =
  <
    TData = Awaited<
      ReturnType<
        typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInterviewTransactionsApiV1PaymentsInterviewTransactionsGet
            >
          >,
          TError,
          TData
        >
      >
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      getListInterviewTransactionsApiV1PaymentsInterviewTransactionsGetQueryOptions(
        params,
        options
      )

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey
    }

    query.queryKey = queryOptions.queryKey

    return query
  }

/**
 * @summary Paddle Webhook
 */
export const paddleWebhookApiV1PaymentsPaddlePost = (
  paddleWebhookApiV1PaymentsPaddlePostBody: PaddleWebhookApiV1PaymentsPaddlePostBody
) => {
  return platformInstance<unknown>({
    url: `/api/v1/payments/paddle`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: paddleWebhookApiV1PaymentsPaddlePostBody
  })
}

export const getPaddleWebhookApiV1PaymentsPaddlePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>,
    TError,
    { data: PaddleWebhookApiV1PaymentsPaddlePostBody },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>,
  TError,
  { data: PaddleWebhookApiV1PaymentsPaddlePostBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>,
    { data: PaddleWebhookApiV1PaymentsPaddlePostBody }
  > = (props) => {
    const { data } = props ?? {}

    return paddleWebhookApiV1PaymentsPaddlePost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PaddleWebhookApiV1PaymentsPaddlePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>
>
export type PaddleWebhookApiV1PaymentsPaddlePostMutationBody =
  PaddleWebhookApiV1PaymentsPaddlePostBody
export type PaddleWebhookApiV1PaymentsPaddlePostMutationError =
  HTTPValidationError

/**
 * @summary Paddle Webhook
 */
export const usePaddleWebhookApiV1PaymentsPaddlePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>,
    TError,
    { data: PaddleWebhookApiV1PaymentsPaddlePostBody },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof paddleWebhookApiV1PaymentsPaddlePost>>,
  TError,
  { data: PaddleWebhookApiV1PaymentsPaddlePostBody },
  TContext
> => {
  const mutationOptions =
    getPaddleWebhookApiV1PaymentsPaddlePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Statistics
 */
export const getStatisticsApiV1StatisticsGet = (
  params?: GetStatisticsApiV1StatisticsGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<GetStatisticsResponse>({
    url: `/api/v1/statistics/`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetStatisticsApiV1StatisticsGetQueryKey = (
  params?: GetStatisticsApiV1StatisticsGetParams
) => {
  return [`/api/v1/statistics/`, ...(params ? [params] : [])] as const
}

export const getGetStatisticsApiV1StatisticsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>,
  TError = HTTPValidationError
>(
  params?: GetStatisticsApiV1StatisticsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetStatisticsApiV1StatisticsGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>
  > = ({ signal }) => getStatisticsApiV1StatisticsGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetStatisticsApiV1StatisticsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>
>
export type GetStatisticsApiV1StatisticsGetQueryError = HTTPValidationError

/**
 * @summary Get Statistics
 */
export const useGetStatisticsApiV1StatisticsGet = <
  TData = Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>,
  TError = HTTPValidationError
>(
  params?: GetStatisticsApiV1StatisticsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStatisticsApiV1StatisticsGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStatisticsApiV1StatisticsGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Get available subscription plans with intelligent caching.
        
        Features:
        - Adaptive TTL caching based on plan stability
        - Database fallback when Paddle API is unavailable
        - Graceful degradation with stale data serving
        - Cache metadata for client-side optimization
        
        The response includes cache metadata to help clients understand data freshness
        and implement appropriate retry strategies.
 * @summary Get subscription plans
 */
export const getSubscriptionPlansApiV1SubscriptionsPlansGet = (
  params?: GetSubscriptionPlansApiV1SubscriptionsPlansGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<PlansListResponse>({
    url: `/api/v1/subscriptions/plans`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetSubscriptionPlansApiV1SubscriptionsPlansGetQueryKey = (
  params?: GetSubscriptionPlansApiV1SubscriptionsPlansGetParams
) => {
  return [`/api/v1/subscriptions/plans`, ...(params ? [params] : [])] as const
}

export const getGetSubscriptionPlansApiV1SubscriptionsPlansGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>
  >,
  TError = HTTPValidationError | SubscriptionErrorResponse
>(
  params?: GetSubscriptionPlansApiV1SubscriptionsPlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>
        >,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetSubscriptionPlansApiV1SubscriptionsPlansGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>>
  > = ({ signal }) =>
    getSubscriptionPlansApiV1SubscriptionsPlansGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetSubscriptionPlansApiV1SubscriptionsPlansGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>>
  >
export type GetSubscriptionPlansApiV1SubscriptionsPlansGetQueryError =
  | HTTPValidationError
  | SubscriptionErrorResponse

/**
 * @summary Get subscription plans
 */
export const useGetSubscriptionPlansApiV1SubscriptionsPlansGet = <
  TData = Awaited<
    ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>
  >,
  TError = HTTPValidationError | SubscriptionErrorResponse
>(
  params?: GetSubscriptionPlansApiV1SubscriptionsPlansGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSubscriptionPlansApiV1SubscriptionsPlansGet>
        >,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetSubscriptionPlansApiV1SubscriptionsPlansGetQueryOptions(
      params,
      options
    )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Get User Subscription
 */
export const getUserSubscriptionApiV1SubscriptionsCurrentGet = (
  signal?: AbortSignal
) => {
  return platformInstance<UserSubscription>({
    url: `/api/v1/subscriptions/current`,
    method: 'GET',
    signal
  })
}

export const getGetUserSubscriptionApiV1SubscriptionsCurrentGetQueryKey =
  () => {
    return [`/api/v1/subscriptions/current`] as const
  }

export const getGetUserSubscriptionApiV1SubscriptionsCurrentGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>
  >,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>
      >,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserSubscriptionApiV1SubscriptionsCurrentGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>>
  > = ({ signal }) => getUserSubscriptionApiV1SubscriptionsCurrentGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetUserSubscriptionApiV1SubscriptionsCurrentGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>>
  >
export type GetUserSubscriptionApiV1SubscriptionsCurrentGetQueryError =
  HTTPValidationError

/**
 * @summary Get User Subscription
 */
export const useGetUserSubscriptionApiV1SubscriptionsCurrentGet = <
  TData = Awaited<
    ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>
  >,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserSubscriptionApiV1SubscriptionsCurrentGet>
      >,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetUserSubscriptionApiV1SubscriptionsCurrentGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Activate Trial Subscription
 */
export const activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost =
  (subscriptionId: string) => {
    return platformInstance<UserSubscription>({
      url: `/api/v1/subscriptions/${subscriptionId}/activate`,
      method: 'POST'
    })
  }

export const getActivateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
        >
      >,
      TError,
      { subscriptionId: string },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
      >
    >,
    TError,
    { subscriptionId: string },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
        >
      >,
      { subscriptionId: string }
    > = (props) => {
      const { subscriptionId } = props ?? {}

      return activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost(
        subscriptionId
      )
    }

    return { mutationFn, ...mutationOptions }
  }

export type ActivateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
      >
    >
  >

export type ActivateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePostMutationError =
  HTTPValidationError

/**
 * @summary Activate Trial Subscription
 */
export const useActivateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
        >
      >,
      TError,
      { subscriptionId: string },
      TContext
    >
  }): UseMutationResult<
    Awaited<
      ReturnType<
        typeof activateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePost
      >
    >,
    TError,
    { subscriptionId: string },
    TContext
  > => {
    const mutationOptions =
      getActivateTrialSubscriptionApiV1SubscriptionsSubscriptionIdActivatePostMutationOptions(
        options
      )

    return useMutation(mutationOptions)
  }

/**
 * Manually refresh user subscription cache
 * @summary Refresh User Subscription
 */
export const refreshUserSubscriptionApiV1SubscriptionsRefreshPut = () => {
  return platformInstance<unknown>({
    url: `/api/v1/subscriptions/refresh`,
    method: 'PUT'
  })
}

export const getRefreshUserSubscriptionApiV1SubscriptionsRefreshPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
      >,
      TError,
      void,
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
    >,
    TError,
    void,
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
      >,
      void
    > = () => {
      return refreshUserSubscriptionApiV1SubscriptionsRefreshPut()
    }

    return { mutationFn, ...mutationOptions }
  }

export type RefreshUserSubscriptionApiV1SubscriptionsRefreshPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
    >
  >

export type RefreshUserSubscriptionApiV1SubscriptionsRefreshPutMutationError =
  HTTPValidationError

/**
 * @summary Refresh User Subscription
 */
export const useRefreshUserSubscriptionApiV1SubscriptionsRefreshPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
    >,
    TError,
    void,
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof refreshUserSubscriptionApiV1SubscriptionsRefreshPut>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getRefreshUserSubscriptionApiV1SubscriptionsRefreshPutMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Appsumo Notification
 */
export const appsumoNotificationApiV1AppsumoNotifyPost = (
  appsumoWebookNotification: AppsumoWebookNotification
) => {
  return platformInstance<unknown>({
    url: `/api/v1/appsumo/notify`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: appsumoWebookNotification
  })
}

export const getAppsumoNotificationApiV1AppsumoNotifyPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>,
    TError,
    { data: AppsumoWebookNotification },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>,
  TError,
  { data: AppsumoWebookNotification },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>,
    { data: AppsumoWebookNotification }
  > = (props) => {
    const { data } = props ?? {}

    return appsumoNotificationApiV1AppsumoNotifyPost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AppsumoNotificationApiV1AppsumoNotifyPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>
  >
export type AppsumoNotificationApiV1AppsumoNotifyPostMutationBody =
  AppsumoWebookNotification
export type AppsumoNotificationApiV1AppsumoNotifyPostMutationError =
  HTTPValidationError

/**
 * @summary Appsumo Notification
 */
export const useAppsumoNotificationApiV1AppsumoNotifyPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>,
    TError,
    { data: AppsumoWebookNotification },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof appsumoNotificationApiV1AppsumoNotifyPost>>,
  TError,
  { data: AppsumoWebookNotification },
  TContext
> => {
  const mutationOptions =
    getAppsumoNotificationApiV1AppsumoNotifyPostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get License Key
 */
export const getLicenseKeyApiV1AppsumoLicenseKeyGetGet = (
  params: GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams,
  signal?: AbortSignal
) => {
  return platformInstance<LicenseResponse>({
    url: `/api/v1/appsumo/license-key/get`,
    method: 'GET',
    params,
    signal
  })
}

export const getGetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryKey = (
  params: GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams
) => {
  return [
    `/api/v1/appsumo/license-key/get`,
    ...(params ? [params] : [])
  ] as const
}

export const getGetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>,
  TError = HTTPValidationError
>(
  params: GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>,
        TError,
        TData
      >
    >
  }
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryKey(params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>
  > = ({ signal }) => getLicenseKeyApiV1AppsumoLicenseKeyGetGet(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>
>
export type GetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryError =
  HTTPValidationError

/**
 * @summary Get License Key
 */
export const useGetLicenseKeyApiV1AppsumoLicenseKeyGetGet = <
  TData = Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>,
  TError = HTTPValidationError
>(
  params: GetLicenseKeyApiV1AppsumoLicenseKeyGetGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLicenseKeyApiV1AppsumoLicenseKeyGetGet>>,
        TError,
        TData
      >
    >
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLicenseKeyApiV1AppsumoLicenseKeyGetGetQueryOptions(
    params,
    options
  )

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Activate License Key
 */
export const activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost = (
  useLicenseKeyRequest: UseLicenseKeyRequest
) => {
  return platformInstance<unknown>({
    url: `/api/v1/appsumo/license-key/activate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: useLicenseKeyRequest
  })
}

export const getActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
      >,
      TError,
      { data: UseLicenseKeyRequest },
      TContext
    >
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
    >,
    TError,
    { data: UseLicenseKeyRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {}

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
      >,
      { data: UseLicenseKeyRequest }
    > = (props) => {
      const { data } = props ?? {}

      return activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost(data)
    }

    return { mutationFn, ...mutationOptions }
  }

export type ActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
    >
  >
export type ActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePostMutationBody =
  UseLicenseKeyRequest
export type ActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePostMutationError =
  HTTPValidationError

/**
 * @summary Activate License Key
 */
export const useActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
    >,
    TError,
    { data: UseLicenseKeyRequest },
    TContext
  >
}): UseMutationResult<
  Awaited<
    ReturnType<typeof activateLicenseKeyApiV1AppsumoLicenseKeyActivatePost>
  >,
  TError,
  { data: UseLicenseKeyRequest },
  TContext
> => {
  const mutationOptions =
    getActivateLicenseKeyApiV1AppsumoLicenseKeyActivatePostMutationOptions(
      options
    )

  return useMutation(mutationOptions)
}

/**
 * @summary Get All Video Avatars
 */
export const getAllVideoAvatarsApiV1VideoAvatarsAllGet = (
  signal?: AbortSignal
) => {
  return platformInstance<VideoAvatarResource[]>({
    url: `/api/v1/video_avatars/all`,
    method: 'GET',
    signal
  })
}

export const getGetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryKey = () => {
  return [`/api/v1/video_avatars/all`] as const
}

export const getGetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>
  > = ({ signal }) => getAllVideoAvatarsApiV1VideoAvatarsAllGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>
>
export type GetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryError =
  HTTPValidationError

/**
 * @summary Get All Video Avatars
 */
export const useGetAllVideoAvatarsApiV1VideoAvatarsAllGet = <
  TData = Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllVideoAvatarsApiV1VideoAvatarsAllGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetAllVideoAvatarsApiV1VideoAvatarsAllGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Create Video Avatar
 */
export const createVideoAvatarApiV1VideoAvatarsCreatePost = (
  bodyCreateVideoAvatarApiV1VideoAvatarsCreatePost: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost
) => {
  const formData = new FormData()
  formData.append(
    'external_id',
    bodyCreateVideoAvatarApiV1VideoAvatarsCreatePost.external_id
  )
  formData.append('file', bodyCreateVideoAvatarApiV1VideoAvatarsCreatePost.file)

  return platformInstance<VideoAvatarResource>({
    url: `/api/v1/video_avatars/create`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

export const getCreateVideoAvatarApiV1VideoAvatarsCreatePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>,
    TError,
    { data: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>,
  TError,
  { data: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>,
    { data: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost }
  > = (props) => {
    const { data } = props ?? {}

    return createVideoAvatarApiV1VideoAvatarsCreatePost(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateVideoAvatarApiV1VideoAvatarsCreatePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>
  >
export type CreateVideoAvatarApiV1VideoAvatarsCreatePostMutationBody =
  BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost
export type CreateVideoAvatarApiV1VideoAvatarsCreatePostMutationError =
  HTTPValidationError

/**
 * @summary Create Video Avatar
 */
export const useCreateVideoAvatarApiV1VideoAvatarsCreatePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>,
    TError,
    { data: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof createVideoAvatarApiV1VideoAvatarsCreatePost>>,
  TError,
  { data: BodyCreateVideoAvatarApiV1VideoAvatarsCreatePost },
  TContext
> => {
  const mutationOptions =
    getCreateVideoAvatarApiV1VideoAvatarsCreatePostMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Update Video Avatar
 */
export const updateVideoAvatarApiV1VideoAvatarsIdPatch = (
  id: string,
  bodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch
) => {
  const formData = new FormData()
  if (bodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch.external_id !== undefined) {
    formData.append(
      'external_id',
      bodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch.external_id
    )
  }
  if (bodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch.file !== undefined) {
    formData.append('file', bodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch.file)
  }

  return platformInstance<unknown>({
    url: `/api/v1/video_avatars/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

export const getUpdateVideoAvatarApiV1VideoAvatarsIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>,
    TError,
    { id: string; data: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>,
  TError,
  { id: string; data: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {}

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>,
    { id: string; data: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch }
  > = (props) => {
    const { id, data } = props ?? {}

    return updateVideoAvatarApiV1VideoAvatarsIdPatch(id, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateVideoAvatarApiV1VideoAvatarsIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>
  >
export type UpdateVideoAvatarApiV1VideoAvatarsIdPatchMutationBody =
  BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch
export type UpdateVideoAvatarApiV1VideoAvatarsIdPatchMutationError =
  HTTPValidationError

/**
 * @summary Update Video Avatar
 */
export const useUpdateVideoAvatarApiV1VideoAvatarsIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>,
    TError,
    { id: string; data: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVideoAvatarApiV1VideoAvatarsIdPatch>>,
  TError,
  { id: string; data: BodyUpdateVideoAvatarApiV1VideoAvatarsIdPatch },
  TContext
> => {
  const mutationOptions =
    getUpdateVideoAvatarApiV1VideoAvatarsIdPatchMutationOptions(options)

  return useMutation(mutationOptions)
}

/**
 * @summary Get Available Video Avatars
 */
export const getAvailableVideoAvatarsApiV1VideoAvatarsGet = (
  signal?: AbortSignal
) => {
  return platformInstance<VideoAvatarResource[]>({
    url: `/api/v1/video_avatars/`,
    method: 'GET',
    signal
  })
}

export const getGetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryKey = () => {
  return [`/api/v1/video_avatars/`] as const
}

export const getGetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>
  >,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ??
    getGetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>>
  > = ({ signal }) => getAvailableVideoAvatarsApiV1VideoAvatarsGet(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>>
  >
export type GetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryError =
  HTTPValidationError

/**
 * @summary Get Available Video Avatars
 */
export const useGetAvailableVideoAvatarsApiV1VideoAvatarsGet = <
  TData = Awaited<
    ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>
  >,
  TError = HTTPValidationError
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableVideoAvatarsApiV1VideoAvatarsGet>>,
      TError,
      TData
    >
  >
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetAvailableVideoAvatarsApiV1VideoAvatarsGetQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey
  }

  query.queryKey = queryOptions.queryKey

  return query
}
